"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8207],{

/***/ 64481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BottomSections; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ../../shared/node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(91932);
;// CONCATENATED MODULE: ./components/Skeletons/FooterSkeleton.tsx



function FooterSkeleton(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
            height: (props === null || props === void 0 ? void 0 : props.height) ? props.height : 250,
            className: "col-12"
        })
    });
}

// EXTERNAL MODULE: ./components/Contact.tsx + 2 modules
var Contact = __webpack_require__(49742);
// EXTERNAL MODULE: ../../shared/node_modules/next/image.js
var next_image = __webpack_require__(53429);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./helpers/class/Consts.ts
var Consts = __webpack_require__(92288);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
;// CONCATENATED MODULE: ./components/footer/menu/FooterMenu.tsx





function FooterMenu(props) {
    var showMenuItems = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_show_menu_items");
    });
    var ref = (0,react.useState)(null), referer = ref[0], setReferer = ref[1];
    (0,react.useEffect)(function() {
        if (window !== undefined) {
            setReferer(window.location.origin + "/");
        }
    }, [
        referer
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showMenuItems == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "d-flex flex-wrap flex-sm-nowrap justify-content-center justify-content-lg-start no-style no-padding text-nowrap font-arial fs-11",
                children: Checkers/* default.isValidArray */.Z.isValidArray(props.menu) && props.menu.map(function(menu, key) {
                    var loggiaUrl = menu.loggiaUrl;
                    if (Checkers/* default.isValidString */.Z.isValidString(loggiaUrl) && loggiaUrl.startsWith("/")) {
                        loggiaUrl = loggiaUrl.substring(1);
                    }
                    return menu.title != null ? // eslint-disable-next-line react/jsx-key
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "inline",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: loggiaUrl != null ? referer + loggiaUrl : menu.urlSlug != null ? referer + menu.urlSlug : "#",
                            className: props.hasOwnProperty("apps") ? props.apps == true ? "p-l-10 p-r-10 opacity-60" : "p-l-10 p-r-10" : "p-l-10 p-r-10",
                            children: menu.title
                        })
                    }, key) : "";
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        })
    });
}

;// CONCATENATED MODULE: ./components/footer/partials/LoggiaSVG.tsx

function LoggiaSVG() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: "loggia_logo_cube",
        "data-name": "loggia_logo_cube",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 97 100",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                className: "loggia_logo_cube_right",
                points: "49.2,45.1 91.7,22 96.6,70.9 49.2,100 "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                className: "loggia_logo_cube_left",
                points: "0,70.9 5,22 47.5,45.1 47.5,100 "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                className: "loggia_logo_cube_top",
                points: "6.1,20.6 48.3,0 90.5,20.6 48.3,43.6 "
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/footer/types/FooterWithApps.tsx





function FooterWithApps(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "footer p-t-40 mt-auto " + (props.footerPaddingClass != null ? props.footerPaddingClass : ""),
        style: props.fixed ? {
            paddingBottom: "7.625rem"
        } : {},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row align-items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-12 col-lg-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row justify-content-center justify-content-lg-start",
                                    children: [
                                        props.iosApp != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-flex justify-content-center w-auto h-auto px-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "h-auto w-auto",
                                                href: props.iosApp,
                                                title: "iosApp",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    layout: "fixed",
                                                    width: 135,
                                                    height: 40,
                                                    src: Consts/* default.AppleAppSvg */.Z.AppleAppSvg,
                                                    alt: "ios_app",
                                                    placeholder: "blur",
                                                    blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                                })
                                            })
                                        }) : "",
                                        props.androidApp != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-flex justify-content-center w-auto h-auto px-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "h-auto w-auto",
                                                href: props.androidApp,
                                                title: "androidApp",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    layout: "fixed",
                                                    width: 135,
                                                    height: 40,
                                                    src: Consts/* default.AndroidAppSvg */.Z.AndroidAppSvg,
                                                    alt: "android_app",
                                                    placeholder: "blur",
                                                    blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                                })
                                            })
                                        }) : ""
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row light-mode",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMenu, {
                                        menu: props.menu,
                                        apps: true
                                    })
                                })
                            ]
                        }),
                        props.registrationNumberText != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex col-12 col-lg-6 justify-content-center justify-content-lg-end align-self-end",
                            style: {
                                marginBottom: "13px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "fs-11 text-master w-auto text-lg-end",
                                style: {
                                    textAlign: "center"
                                },
                                children: [
                                    props.registrationNumberText,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "fw-bold",
                                        children: props.registrationNumber
                                    })
                                ]
                            })
                        }) : ""
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-design-color pt-3 pb-3 " + props.footerClass,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex flex-column col-12 col-lg-6 align-items-center align-items-lg-start text-lg-start",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        props.iosAppText != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "fs-11 no-margin",
                                            children: props.iosAppText
                                        }) : "",
                                        props.androidAppText != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "fs-11 no-margin",
                                            children: props.androidAppText
                                        }) : "",
                                        props.loggiaBadgeText != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "fs-11 no-margin",
                                            children: props.loggiaBadgeText
                                        }) : ""
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    id: "w3c_div",
                                    className: "col-12 col-lg-6 justify-content-center justify-content-lg-end text-lg-end py-3 py-lg-0",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "fs-11",
                                            children: [
                                                "Copyright \xa9 ",
                                                props.title,
                                                ". All rights reserved."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            id: "w3c",
                                            href: "https://validator.w3.org/nu/?doc=" + window.location,
                                            "aria-labelledby": "w3c_div",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            title: "w3c",
                                            style: {
                                                width: 56,
                                                height: 20
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                layout: "fixed",
                                                width: 56,
                                                height: 20,
                                                src: Consts/* default.W3cValidatorSvg */.Z.W3cValidatorSvg,
                                                alt: "w3c"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            id: "ackecker_form",
                                            target: "_blank",
                                            method: "post",
                                            action: "https://achecker.achecks.ca/checker/index.php",
                                            style: {
                                                display: "inline-block"
                                            },
                                            className: "ng-pristine ng-valid",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "hidden",
                                                    name: "uri",
                                                    id: "checkuri",
                                                    value: "window.location}"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    id: "wcag_form_submit",
                                                    href: "https://achecks.org/checker/index.php",
                                                    "aria-labelledby": "ackecker_form",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    title: "wcag_form_submit",
                                                    style: {
                                                        width: 56,
                                                        height: 20
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        layout: "fixed",
                                                        width: 56,
                                                        height: 20,
                                                        src: Consts/* default.WcagValidatorSvg */.Z.WcagValidatorSvg,
                                                        alt: "wcag"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        props.hasLoggiaBadge ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row justify-content-center text-center py-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.loggia.gr",
                                target: "_blank",
                                "aria-label": "Made with Loggia's SimpleLodge",
                                title: "Made with Loggia's SimpleLodge",
                                rel: "noreferrer",
                                className: "w-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoggiaSVG, {})
                            })
                        }) : ""
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/footer/types/FooterWithoutApps.tsx





function FooterWithoutApps(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "footer bg-design-color pt-5 xs-p-b-95 mt-auto " + props.footerClass + " " + (props.footerPaddingClass != null ? props.footerPaddingClass : ""),
        style: props.fixed ? {
            paddingBottom: "7.625rem"
        } : {},
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 col-lg-6 justify-content-center justify-content-lg-start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMenu, {
                                menu: props.menu
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "w3c_div",
                            className: "col-12 col-lg-6 justify-content-center justify-content-lg-end text-lg-end py-3 py-lg-0",
                            style: {
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "fs-11",
                                    children: [
                                        "Copyright \xa9 ",
                                        props.title,
                                        ". All rights reserved."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    id: "w3c",
                                    href: "https://validator.w3.org/nu/?doc=" + window.location,
                                    "aria-labelledby": "w3c_div",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    title: "w3c",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        layout: "fixed",
                                        width: 56,
                                        height: 20,
                                        src: Consts/* default.W3cValidatorSvg */.Z.W3cValidatorSvg,
                                        alt: "w3c"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    id: "ackecker_form",
                                    target: "_blank",
                                    method: "post",
                                    action: "https://achecker.achecks.ca/checker/index.php",
                                    style: {
                                        display: "inline-block"
                                    },
                                    className: "ng-pristine ng-valid",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "hidden",
                                            name: "uri",
                                            id: "checkuri",
                                            value: "https://example.com"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            id: "wcag_form_submit",
                                            href: "https://achecks.org/checker/index.php",
                                            "aria-labelledby": "ackecker_form",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            title: "wcag_form_submit",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                layout: "fixed",
                                                width: 56,
                                                height: 20,
                                                src: Consts/* default.WcagValidatorSvg */.Z.WcagValidatorSvg,
                                                alt: "wcag"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row justify-content-center text-center py-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.loggia.gr",
                        target: "_blank",
                        "aria-label": "Made with Loggia's SimpleLodge",
                        title: "Made with Loggia's SimpleLodge",
                        rel: "noreferrer",
                        className: "w-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoggiaSVG, {})
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/Footer.tsx




function Footer(props) {
    var footerClass = null;
    if (props.designMode != null) {
        if (props.designMode) footerClass = "dark-mode";
        else footerClass = "light-mode";
    } else {
        footerClass = "light-mode";
    }
    if (props.footerContent.content != undefined) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                className: "bg-design-color xs-p-b-85 " + (props.footerPaddingClass != undefined ? props.footerPaddingClass : ""),
                dangerouslySetInnerHTML: {
                    __html: props.footerContent.content.app_section_content
                }
            })
        });
    } else return props.iosApp != null || props.androidApp != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWithApps, {
        iosApp: props.iosApp,
        androidApp: props.androidApp,
        iosAppText: props.iosAppText,
        androidAppText: props.androidAppText,
        hasLoggiaBadge: props.hasLoggiaBadge,
        loggiaBadgeText: props.loggiaBadgeText,
        registrationNumber: props.registrationNumber,
        registrationNumberText: props.registrationNumberText,
        footerPaddingClass: props.footerPaddingClass,
        title: props.title,
        footerClass: footerClass,
        menu: props.menu
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWithoutApps, {
        footerPaddingClass: props.footerPaddingClass,
        footerClass: footerClass,
        menu: props.menu
    });
}

// EXTERNAL MODULE: ./components/ViewPort.tsx
var ViewPort = __webpack_require__(39806);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8158);
// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(27307);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(87091);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(8019);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/lab/Alert/Alert.js + 7 modules
var Alert = __webpack_require__(62415);
;// CONCATENATED MODULE: ./components/templates/index/sections/NewsletterSection.tsx











function NewsletterSection(param) {
    var title = param.title, subtitle = param.subtitle, description = param.description, newsletterAskFirstname = param.newsletterAskFirstname, newsletterAskLastname = param.newsletterAskLastname, newsletterAskPhone = param.newsletterAskPhone, newsletterBgImage = param.newsletterBgImage, newsletterBackground = param.newsletterBackground, darkMode = param.darkMode;
    var calculateColumns = function() {
        var columns = 0;
        if (newsletterAskFirstname) {
            columns++;
        }
        if (newsletterAskLastname) {
            columns++;
        }
        if (newsletterAskPhone) {
            columns++;
        }
        switch(columns){
            case 1:
                return "col-12";
            case 2:
                return "col-6";
            case 3:
                return "col-4";
            default:
                return null;
        }
    };
    var pageId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var ref = (0,react.useState)(false), formSubmitting = ref[0], setFormSubmitting = ref[1];
    var ref1 = (0,react.useState)(false), showResponseMessage = ref1[0], setShowResponseMessage = ref1[1];
    var ref2 = (0,react.useState)(null), formSuccess = ref2[0], setFormSuccess = ref2[1];
    var ref3 = (0,react.useState)(false), notice = ref3[0], setNotice = ref3[1];
    var ref4 = (0,react.useState)(""), responseMessage = ref4[0], setResponseMessage = ref4[1];
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var data, formObject, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        setFormSubmitting(true);
                        data = new FormData(event.currentTarget);
                        formObject = Object.fromEntries(data.entries());
                        return [
                            4,
                            (0,client/* sendNewsletterForm */.eK)({
                                "page_id": pageId
                            }, formObject)
                        ];
                    case 1:
                        response = _state.sent();
                        setShowResponseMessage(true);
                        if (response.success == 1) {
                            setFormSuccess(true);
                            if (response.notice == 1) {
                                setNotice(true);
                            }
                        } else {
                            setFormSuccess(false);
                        }
                        if (Checkers/* default.isValidString */.Z.isValidString(response.message)) {
                            setResponseMessage(response.message);
                        }
                        setFormSubmitting(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var getNewsletterBackgroundColor = function() {
        if (darkMode === true || darkMode === "1") {
            return "rgba(0, 0, 0)";
        }
        return "rgba(255, 255, 255)";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "p-b-100 p-t-100 bg-master-darkest design_color",
                "data-pages-bg-image": newsletterBgImage != null ? newsletterBgImage : "",
                "data-pages-bg-webp": newsletterBgImage != null ? newsletterBgImage : "",
                style: {
                    backgroundSize: "cover",
                    backgroundPosition: "center 37.1366%",
                    backgroundImage: "url(" + (newsletterBgImage != null ? newsletterBgImage : "") + ")"
                },
                "data-pages": "parallax",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "background-overlay",
                        style: {
                            backgroundColor: Checkers/* default.isHexColor */.Z.isHexColor(newsletterBackground) ? newsletterBackground : getNewsletterBackgroundColor(),
                            opacity: Checkers/* default.isHexColor */.Z.isHexColor(newsletterBackground) ? 1 : 0.5
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        style: {
                            zIndex: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row justify-content-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-sm-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "block-title m-b-0 text-master text-center " + (0,MethodHelper/* textColor */.zP)(darkMode),
                                        children: Checkers/* default.isValidString */.Z.isValidString(title) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: title
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: "Stay in touch"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: (0,MethodHelper/* textColor */.zP)(darkMode) + " text-master text-center m-t-5",
                                        children: Checkers/* default.isValidString */.Z.isValidString(subtitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: subtitle
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: "Sign up now and receive exclusive offers and benefits."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "small p-t-0 text-master text-center " + (0,MethodHelper/* textColor */.zP)(darkMode),
                                        children: Checkers/* default.isValidString */.Z.isValidString(subtitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: description
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: "We value your privacy. None of the details supplied will be shared with external parties"
                                        })
                                    }),
                                    showResponseMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: formSuccess ? !notice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                            severity: "success",
                                            sx: {
                                                mb: "20px"
                                            },
                                            children: responseMessage
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                            severity: "warning",
                                            sx: {
                                                mb: "20px"
                                            },
                                            children: responseMessage
                                        }) : formSuccess != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                                            severity: "error",
                                            sx: {
                                                mb: "20px"
                                            },
                                            children: responseMessage
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                        onSubmit: handleSubmit,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: ((0,MethodHelper/* isDarkMode */.Yc)(darkMode) ? "b-border-dark" : "") + " row",
                                            children: [
                                                newsletterAskFirstname ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: calculateColumns() + " p-l-5 p-r-5",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "input-class form-group form-group-default bg-white b-transparent-master required",
                                                            style: {
                                                                backgroundColor: "transparent !important"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "first_name",
                                                                    className: (0,MethodHelper/* textColor */.zP)(darkMode) + " bold text-uppercase letter-sp-normal fs-12",
                                                                    children: "First name"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    id: "first_name",
                                                                    name: "first_name",
                                                                    type: "text",
                                                                    className: "form-control",
                                                                    required: true,
                                                                    style: {
                                                                        backgroundColor: "transparent !important"
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                newsletterAskLastname ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: calculateColumns() + " p-l-5 p-r-5",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "input-class form-group form-group-default bg-white b-transparent-master required",
                                                            style: {
                                                                backgroundColor: "transparent !important"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "last_name",
                                                                    className: (0,MethodHelper/* textColor */.zP)(darkMode) + " bold text-uppercase letter-sp-normal fs-12",
                                                                    children: "Last name"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    id: "last_name",
                                                                    name: "last_name",
                                                                    type: "text",
                                                                    className: "form-control",
                                                                    style: {
                                                                        backgroundColor: "transparent !important"
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                newsletterAskPhone ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: calculateColumns() + " p-l-5 p-r-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "input-class form-group form-group-default bg-white b-transparent-master required",
                                                        style: {
                                                            backgroundColor: "transparent !important"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "phone",
                                                                className: (0,MethodHelper/* textColor */.zP)(darkMode) + " bold text-uppercase letter-sp-normal fs-12",
                                                                children: "Phone"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                id: "phone",
                                                                name: "phone",
                                                                type: "tel",
                                                                className: "form-control",
                                                                style: {
                                                                    backgroundColor: "transparent !important"
                                                                },
                                                                // pattern="[0-12]{3}"
                                                                placeholder: "",
                                                                required: true
                                                            })
                                                        ]
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-12 p-l-5 p-r-5",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "form-group form-group-default required input-group bg-transparent b-a b-transparent-master row d-flex align-items-center m-auto",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "col required",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                            htmlFor: "frm_newsletter_email",
                                                                            className: (0,MethodHelper/* textColor */.zP)(darkMode) + " text-master p-l-0",
                                                                            children: "Email Address"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            type: "email",
                                                                            name: "frm_newsletter_email",
                                                                            id: "frm_newsletter_email",
                                                                            "data-ng-model": "newsletter_email",
                                                                            className: (0,MethodHelper/* textColor */.zP)(darkMode) + " form-control text-master required pull-left required p-l-0",
                                                                            placeholder: "Example@mailserver.com",
                                                                            "aria-required": "true",
                                                                            "aria-invalid": "true",
                                                                            required: true
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-auto",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "input-group-btn pull-right",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                            className: "btn btn-master m-r-10 btn-cons b_r_3",
                                                                            type: "submit",
                                                                            children: [
                                                                                formSubmitting && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                                    icon: pro_regular_svg_icons/* faSpinner */.LM3,
                                                                                    spin: true
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: "Subscribe!"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/react-elfsight-widget/dist/react-elfsight-widget.esm.js
var react_elfsight_widget_esm = __webpack_require__(5269);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(53331);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(72976);
;// CONCATENATED MODULE: ./components/BottomSections.tsx














function BottomSections(props) {
    var contact_section = props.contactSection;
    var footer_section = props.footerSection;
    var isMobile = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isMobile"];
    });
    var isTablet = (0,es/* useSelector */.v9)(function(state) {
        return state["appSettings"]["isTablet"];
    });
    var app_data = props.app_data;
    var head = props.head;
    var app = props.app;
    var locations = props.locations;
    var footer = props.footer;
    var isDesktop = props.isDesktop;
    var captchaSiteKey = props.captchaSiteKey;
    var contactFormInFooter = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_contact_in_different_page") == 1 ? false : true;
    });
    var showChatIconsMobile = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_chat_icons_side_show_mobile") == 1 ? true : false;
    });
    var showChatIconsDesktop = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_chat_icons_side_show_desktop") == 1 ? true : false;
    });
    var showChatIconWhatapp = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_chat_icon_whatsapp");
    });
    var showChatIconViber = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_chat_icon_viber");
    });
    var enableNewsletter = app.enableNewsletter;
    var newsletterAskFirstname = app.newsletterAskFirstname;
    var newsletterAskLastname = app.newsletterAskLastname;
    var newsletterAskPhone = app.newsletterAskPhone;
    var newsletterTitle = app.newsletterTitle;
    var newsletterSubtitle = app.newsletterSubtitle;
    var newsletterDesc = app.newsletterDesc;
    var newsletterBackground = app.newsletterBgColor;
    var newsletterDarkMode = app.builder.builder_newsletter_dark_mode;
    var htmlSections = props.htmlSections != null && props.htmlSections.hasOwnProperty("app_sections") ? props.htmlSections.app_sections : null;
    var newsletterBackgroundHandler = function() {
        if (Checkers/* default.isValidString */.Z.isValidString(props.app.newsletterImage)) {
            return props.app.newsletterImage;
        }
        if (props.app.pageMedia != null && props.app.pageMedia.length >= 2) {
            return props.app.pageMedia[1].image;
        }
        return Checkers/* default.isValidString */.Z.isValidString(props.app.newsletterImage) ? props.app.newsletterImage : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            Checkers/* default.valueToBoolean */.Z.valueToBoolean(isMobile) && showChatIconsMobile || Checkers/* default.valueToBoolean */.Z.valueToBoolean(isDesktop) && showChatIconsDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: Checkers/* default.isValidString */.Z.isValidString(showChatIconViber) || Checkers/* default.isValidString */.Z.isValidString(showChatIconWhatapp) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "chat-icons",
                        children: [
                            Checkers/* default.isValidString */.Z.isValidString(showChatIconViber) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "icon viber",
                                    href: showChatIconViber,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_brands_svg_icons/* faViber */.oYh,
                                        className: "",
                                        size: "xl"
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            Checkers/* default.isValidString */.Z.isValidString(showChatIconWhatapp) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "icon whatsapp",
                                    href: showChatIconWhatapp,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_brands_svg_icons/* faWhatsapp */.VHX,
                                        className: "",
                                        size: "xl"
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            htmlSections != null && Checkers/* default.isValidArray */.Z.isValidArray(htmlSections) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container-fluid overflow-hidden",
                    children: htmlSections.map(function(section, key) {
                        return section.app_section_content != null ? section.app_section_content.includes("elfsight-app") ? section.app_section_content.split("elfsight-app-")[1] != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_elfsight_widget_esm/* ElfsightWidget */.j, {
                            widgetID: section.app_section_content.split("elfsight-app-")[1].split('"></div>')[0]
                        }, key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            enableNewsletter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterSection, {
                newsletterAskFirstname: newsletterAskFirstname,
                newsletterAskLastname: newsletterAskLastname,
                newsletterAskPhone: newsletterAskPhone,
                title: newsletterTitle,
                subtitle: newsletterSubtitle,
                description: newsletterDesc,
                newsletterBgImage: newsletterBackgroundHandler(),
                newsletterBackground: newsletterBackground,
                darkMode: newsletterDarkMode
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            contactFormInFooter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: contact_section && /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact/* default */.Z, {
                    isDesktop: isDesktop,
                    contactFormTitle: app.contactFormTitle,
                    locations: locations != null ? locations.hasOwnProperty("page_locations") ? locations.page_locations : null : null,
                    captchaSiteKey: captchaSiteKey,
                    showContactSection: app.showContactSection,
                    showContactForm: app.showContactForm,
                    showName: app.contactAskName,
                    showEmail: app.contactAskEmail,
                    showPhone: app.contactAskPhone,
                    showDates: app.contactAskDates,
                    showDestination: app.contactAskDestination,
                    searchbarRadius: app.searchbarRadius != null ? app.searchbarRadius.length > 0 ? app.searchbarRadius.length : null : null,
                    contactPhoneOverride: app.builder.builder_contact_page_phone,
                    contactEmailOverride: app.builder.builder_contact_page_email,
                    contactTitleOverride: app.builder.builder_contact_page_title
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            footer_section ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewPort/* default */.Z, {
                ref: props.footerRef,
                parentClass: "row w-100 m-0",
                skeletonItem: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSkeleton, {
                    height: app_data.has_android_app || app_data.has_ios_app ? 250 : 172
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                    footerPaddingClass: props.footerPaddingClass,
                    isDesktop: isDesktop,
                    designMode: app.designMode,
                    menu: footer.menu,
                    footerContent: footer,
                    title: head.data.hasOwnProperty("titleOfficial") && head.data.titleOfficial != null ? head.data.titleOfficial : head.data.hasOwnProperty("title") ? head.data.title : null,
                    fixed: app.enableBooking && app.bookingSearchbarWidth && !app.bookingSearchbarPosition,
                    iosApp: app_data.has_ios_app ? app_data.ios_app_link : null,
                    androidApp: app_data.has_android_app ? app_data.android_app_link : null,
                    iosAppText: app_data.has_ios_app ? app_data.ios_app_text : null,
                    androidAppText: app_data.has_android_app ? app_data.android_app_text : null,
                    hasLoggiaBadge: app_data.has_loggia_badge,
                    loggiaBadgeText: app_data.has_loggia_badge ? app_data.loggia_badge_text : null,
                    registrationNumber: app_data.registration_number,
                    registrationNumberText: app_data.registration_number_text
                })
            }) : "",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "btn btn-lg btn-primary btn-design-color rounded-circle shadow-5 z-index-5",
                id: "btn-back-to-top",
                "aria-label": "Back to top",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    className: "fs-16",
                    icon: pro_solid_svg_icons/* faArrowUp */.FPD
                })
            })
        ]
    });
}


/***/ }),

/***/ 49742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Contact; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ./components/contact/ContactForm.tsx + 2 modules
var ContactForm = __webpack_require__(46532);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
;// CONCATENATED MODULE: ./components/contact/ContactLocations.tsx





function ContactLocations(props) {
    var url = null;
    if (props.latitude != null && props.longitude != null) {
        url = "https://www.google.com/maps/search/?api=1&amp;query=" + props.latitude + "," + props.longitude;
    } else {
        url = null;
    }
    var locations_class = "col-12 col-sm-12 col-md-6 pe-md-5";
    if (!props.showContactForm) {
        locations_class = "col-md-4 offset-md-4 col-sm-12 offset-sm-0";
    }
    var showBranchesLocations = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_contact_show_branches") == "1" ? true : false;
    });
    var contactEmail = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_contact_page_email");
    });
    var contactEmailOverride = Checkers/* default.isValidString */.Z.isValidString(props.contactEmailOverride) ? props.contactEmailOverride : contactEmail;
    var contactPhoneBlock = props.hasOwnProperty("contactPhone") ? props.contactPhone : null;
    var contactEmailBlock = props.hasOwnProperty("contactEmail") ? props.contactEmail : null;
    // useEffect( () => {
    //   console.log("forDebug", "contactEmailOverride", contactEmailOverride)
    //   console.log("forDebug", "showBranchesLocations", showBranchesLocations)
    //   console.log("forDebug", "props.locations", props.locations)
    // })
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: locations_class,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "m-b-20 hidden-xs",
                children: props.contactFormTitle != null ? props.contactFormTitle : "How can we assist you?"
            }),
            props.locations != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex flex-row flex-wrap w-100 m-0",
                children: props.locations.map(function(location, key) {
                    if (key > 0 && !showBranchesLocations) {
                        return;
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pe-3",
                            children: [
                                location.location_title != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-uppercase letter-sp-normal fw-normal hint-text m-b-0",
                                    children: Checkers/* default.isValidString */.Z.isValidString(props.contactTitleOverride) ? props.contactTitleOverride : location.location_title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                                    className: "my-2 mb-3",
                                    children: [
                                        Checkers/* default.isValidString */.Z.isValidString(location.address) ? location.address : "",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        Checkers/* default.isValidString */.Z.isValidString(location.city) ? location.city : "",
                                        Checkers/* default.isValidString */.Z.isValidString(location.zip) ? ", " + location.zip : "",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        Checkers/* default.isValidString */.Z.isValidString(location.country) ? location.country : ""
                                    ]
                                }),
                                url != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-uppercase letter-sp-normal fw-bold small-text hint-text no-margin p-r-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        target: "_blank",
                                        className: "view-map",
                                        href: url,
                                        rel: "noreferrer",
                                        children: "View on map"
                                    })
                                }) : "",
                                location.hasOwnProperty("items") ? location.items.length > 0 ? location.items.map(function(item, key) {
                                    return item.slug.includes("phone") ? item.value != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                        children: Checkers/* default.isValidString */.Z.isValidString(props.contactPhoneOverride) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, "location-items-" + key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: contactPhoneBlock != null && contactPhoneBlock.hasOwnProperty("app_section_content") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: contactPhoneBlock.app_section_content
                                                    }
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "letter-sp-normal fw-bold no-margin p-r-10",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-uppercase letter-sp-normal fw-bold text-master no-margin fs-12 p-r-10",
                                                        children: "Tel"
                                                    }),
                                                    item.phone_prefix != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: "tel:+" + item.phone_prefix + item.value,
                                                        className: "fs-14 fw-bold hint-text text-master text-design-color",
                                                        children: [
                                                            "(+",
                                                            item.phone_prefix,
                                                            ") ",
                                                            item.value
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "tel:" + item.value,
                                                        className: "fs-14 fw-bold hint-text text-master text-design-color",
                                                        children: item.value
                                                    })
                                                ]
                                            }, key)
                                        })
                                    }, "location-items-phone-" + key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, "location-items-" + key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                        children: contactEmailBlock != null && contactEmailBlock.hasOwnProperty("app_section_content") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: contactEmailBlock.app_section_content
                                                }
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: Checkers/* default.isValidString */.Z.isValidString(contactEmailOverride) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}, "location-items-email-" + key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: item.slug.includes("email") ? item.value != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "letter-sp-normal fw-bold no-margin p-r-10",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-uppercase letter-sp-normal fw-bold text-master no-margin fs-12 p-r-10",
                                                            children: "Email"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "mailto:" + item.value,
                                                            className: "fs-14 fw-bold hint-text text-master text-design-color",
                                                            children: item.value
                                                        })
                                                    ]
                                                }, key) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                            })
                                        })
                                    }, "location-items-email-" + key);
                                }) : "" : "",
                                Checkers/* default.isValidString */.Z.isValidString(props.contactPhoneOverride) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "contactPhoneOverride letter-sp-normal fw-bold no-margin p-r-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-uppercase letter-sp-normal fw-bold text-master no-margin fs-12 p-r-10",
                                                children: "Tel"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "tel:" + props.contactPhoneOverride,
                                                className: "fs-14 fw-bold hint-text text-master text-design-color",
                                                children: props.contactPhoneOverride
                                            })
                                        ]
                                    }, key)
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                Checkers/* default.isValidString */.Z.isValidString(contactEmailOverride) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "letter-sp-normal fw-bold no-margin p-r-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-uppercase letter-sp-normal fw-bold text-master no-margin fs-12 p-r-10",
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:" + contactEmailOverride,
                                                className: "fs-14 fw-bold hint-text text-master text-design-color",
                                                children: contactEmailOverride
                                            })
                                        ]
                                    }, key)
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            ]
                        }, key)
                    });
                })
            }) : ""
        ]
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(91932);
;// CONCATENATED MODULE: ./components/Skeletons/ContactSkeleton.tsx



function ContactSkeleton(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-100",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            height: 42,
                            className: "col-12 col-sm-8 b-rad-md mb-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            height: 195,
                            width: 250,
                            className: "b-rad-md mb-1"
                        })
                    ]
                }),
                props.showContactForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-100",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 25,
                                    className: "w-100 b-rad-md mb-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 50,
                                        className: "w-100 b-rad-md mb-1"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 50,
                                        className: "w-100 b-rad-md mb-1"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 50,
                                    className: "w-100 b-rad-md mb-1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    height: 150,
                                    className: "w-100 b-rad-md mb-1"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/ViewPort.tsx
var ViewPort = __webpack_require__(39806);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(53331);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/lab/Alert/Alert.js + 7 modules
var Alert = __webpack_require__(62415);
;// CONCATENATED MODULE: ./components/Contact.tsx












function Contact(props) {
    var isSuccess = props.isSuccess != undefined ? props.isSuccess : false;
    var showContactForm = props.showContactForm != undefined ? props.showContactForm : true;
    var contactPhoneOverride = props.contactPhoneOverride != undefined ? props.contactPhoneOverride : null;
    var contactEmailOverride = props.contactEmailOverride != undefined ? props.contactEmailOverride : null;
    var contactTitleOverride = props.contactTitleOverride != undefined ? props.contactTitleOverride : null;
    var contactPhone = props.hasOwnProperty("contactHtml") && props.contactHtml.hasOwnProperty("contact_phone") && props.contactHtml.contact_phone != null ? props.contactHtml.contact_phone : null;
    var contactEmail = props.hasOwnProperty("contactHtml") && props.contactHtml.hasOwnProperty("contact_email") && props.contactHtml.contact_email != null ? props.contactHtml.contact_email : null;
    var showSocial = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean((0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_social"));
    });
    var builderSettings = (0,es/* useSelector */.v9)(function(state) {
        return state["builderSettingsData"];
    });
    var facebookLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_social_facebook");
    });
    var instagramLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_social_instagram");
    });
    var linkedinLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_social_linkedin");
    });
    var twitterLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_social_twitter");
    });
    var youtubeLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_social_youtube");
    });
    var whatappLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_general_show_social_whatsapp");
    });
    // useEffect( () => {
    //   console.log("forDebug", "showSocial", showSocial)
    //   console.log("forDebug", "facebookLink", facebookLink)
    //   console.log("forDebug", "builderSettings", builderSettings)
    // })
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.showContactSection ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            id: "contact",
            className: "bg-master-lightest py-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewPort/* default */.Z, {
                parentClassName: "container-fluid mb-5",
                skeletonItem: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactSkeleton, {
                    showContactForm: props.showContactForm
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactLocations, {
                                    locations: props.locations,
                                    showContactForm: showContactForm,
                                    contactFormTitle: props.contactFormTitle,
                                    contactPhoneOverride: contactPhoneOverride,
                                    contactEmailOverride: contactEmailOverride,
                                    contactTitleOverride: contactTitleOverride,
                                    contactPhone: contactPhone,
                                    contactEmail: contactEmail
                                }),
                                isSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-12 col-sm-12 col-md-6 ps-md-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* default */.Z, {
                                            severity: "success",
                                            sx: {
                                                mb: "20px"
                                            },
                                            children: [
                                                "Thank you for reaching out!",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "Your message has been successfully received and will get back to you as soon as possible."
                                            ]
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: props.showContactForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm/* default */.Z, {
                                        captchaSiteKey: props.captchaSiteKey,
                                        showDestination: props.showDestination,
                                        searchbarRadius: props.searchbarRadius,
                                        insideSingleProperty: false
                                    }) : ""
                                }),
                                props.contactHtml != undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: props.contactHtml.contact_html
                                    }
                                }) : ""
                            ]
                        })
                    }),
                    showSocial ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container m-t-50",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-left font-arial sm-text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "no-style fs-12 no-padding pull-right sm-pull-reset xs-m-t-20",
                                        children: [
                                            Checkers/* default.isValidString */.Z.isValidString(facebookLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "inline no-padding",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: facebookLink,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        className: "custom_font_color text-master p-l-30 sm-p-r-10 sm-p-l-10",
                                                        "aria-label": "Facebook Page",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: free_brands_svg_icons/* faFacebookF */.AYu,
                                                                className: "fs-36",
                                                                size: "2xl"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "hidden",
                                                                children: "Facebook"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            Checkers/* default.isValidString */.Z.isValidString(instagramLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "inline no-padding",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: instagramLink,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        className: "custom_font_color text-master p-l-30 sm-p-r-10 sm-p-l-10",
                                                        "aria-label": "Instagram Page",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: free_brands_svg_icons/* faInstagram */.Zzi,
                                                                className: "fs-36",
                                                                size: "xl"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "hidden",
                                                                children: "Instagram"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            Checkers/* default.isValidString */.Z.isValidString(youtubeLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "inline no-padding",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: youtubeLink,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        className: "custom_font_color text-master p-l-30 sm-p-r-10 sm-p-l-10",
                                                        "aria-label": "YouTube Page",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: free_brands_svg_icons/* faYoutube */.opf,
                                                                className: "fs-36",
                                                                size: "xl"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "hidden",
                                                                children: "YouTube"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            Checkers/* default.isValidString */.Z.isValidString(twitterLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "inline no-padding",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: twitterLink,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        className: "custom_font_color text-master p-l-30 sm-p-r-10 sm-p-l-10",
                                                        "aria-label": "Twitter Page",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: free_brands_svg_icons/* faTwitter */.mdU,
                                                                className: "fs-36",
                                                                size: "xl"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "hidden",
                                                                children: "Twitter"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            Checkers/* default.isValidString */.Z.isValidString(whatappLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "inline no-padding",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: whatappLink,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        className: "custom_font_color text-master p-l-30 sm-p-r-10 sm-p-l-10",
                                                        "aria-label": "Pinterest Page",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: free_brands_svg_icons/* faWhatsapp */.VHX,
                                                                className: "fs-36",
                                                                size: "xl"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "hidden",
                                                                children: "Pinterest"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            Checkers/* default.isValidString */.Z.isValidString(linkedinLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "inline no-padding",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: linkedinLink,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        className: "custom_font_color text-master p-l-30 sm-p-r-10 sm-p-l-10",
                                                        "aria-label": "LinkedIn Page",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: free_brands_svg_icons/* faLinkedinIn */.hwn,
                                                                className: "fs-36",
                                                                size: "xl"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "hidden",
                                                                children: "LinkedIn"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "clearfix m-b-20"
                                    })
                                ]
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
}


/***/ }),

/***/ 60314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/styled-jsx/style.js
var style = __webpack_require__(17334);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(76191);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(72976);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/base/NoSsr/NoSsr.js
var NoSsr = __webpack_require__(38751);
// EXTERNAL MODULE: ../../shared/node_modules/next/dynamic.js
var dynamic = __webpack_require__(18256);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../shared/node_modules/react-bootstrap/esm/Modal.js + 50 modules
var Modal = __webpack_require__(94549);
// EXTERNAL MODULE: ../../shared/node_modules/next/router.js
var next_router = __webpack_require__(34357);
;// CONCATENATED MODULE: ./components/header/partials/HeaderCustomModal.tsx





var CustomModal = function(param) {
    var modalName = param.modalName, className = param.className, modalSize = param.modalSize, closeModal = param.closeModal, showModal = param.showModal, setShowModal = param.setShowModal, children = param.children, modalHeaderClass = param.modalHeaderClass, falTimes = param.falTimes, modalBodyClass = param.modalBodyClass;
    // const [ showModal, setShowModal ] = useState<boolean>( show || false );
    var router = (0,next_router.useRouter)();
    var hasHash = router.asPath.includes("#");
    var openHandler = function() {
        if (!hasHash) {
            router.push({
                hash: modalName + ""
            }, undefined, {
                scroll: false
            });
        }
        setShowModal(true);
    };
    var closeHandler = function() {
        closeModal();
        setShowModal(false);
        if (showModal) {
            router.back();
        }
    };
    var clickOutSideHandler = function() {
        closeModal();
        setShowModal(false);
    };
    (0,react.useEffect)(function() {
        if (showModal) openHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showModal
    ]);
    (0,react.useEffect)(function() {
        if (!hasHash && showModal) clickOutSideHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasHash
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        id: "modal-menu",
        className: className,
        size: modalSize,
        show: showModal,
        onHide: closeHandler,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                className: "Modal__header ".concat(modalHeaderClass),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: "btn-close btn-no-outline background-none w-auto h-auto",
                    "aria-label": "Close",
                    onClick: closeHandler,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: falTimes,
                        className: "text-black",
                        style: {
                            fontSize: "16px"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                className: modalBodyClass,
                children: children
            })
        ]
    });
};
/* harmony default export */ var HeaderCustomModal = (/*#__PURE__*/(0,react.memo)(CustomModal));

// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
// EXTERNAL MODULE: ../../shared/node_modules/next/link.js
var next_link = __webpack_require__(75547);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../shared/node_modules/react-select/async-creatable/dist/react-select.esm.js + 1 modules
var react_select_esm = __webpack_require__(7398);
// EXTERNAL MODULE: ../../shared/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(96916);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(8019);
;// CONCATENATED MODULE: ./components/header/partials/SearchIcon.tsx












// import {ClickAwayListener} from "@mui/material";
function SearchIcon(props) {
    var customSearch = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["search"];
    });
    // console.log( "pageId", pageId )
    var pageId = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var ref = (0,react.useState)(null), selectedSearchLocation = ref[0], setSelectedSearchLocation = ref[1];
    var toggleTopSearch = function toggleTopSearch() {
        jquery_default()(".search-wrapper").fadeToggle();
    };
    var router = (0,next_router.useRouter)();
    var handleInputChange = function(input) {
        setSelectedSearchLocation(input);
        var location_slug = input.slug;
        var location_val = input.value;
        var location_data = location_val.split("_");
        var location_type = location_data[0];
        var location_id = location_data[1];
        switch(location_type){
            case "property":
                if (Checkers/* default.isValidString */.Z.isValidString(location_slug)) {
                    toggleTopSearch();
                    router.push(location_slug);
                } else {
                    toggleTopSearch();
                    router.push("/property/" + location_id);
                }
                break;
            case "destination":
                if (Checkers/* default.isValidString */.Z.isValidString(location_slug)) {
                    toggleTopSearch();
                    router.push(location_slug);
                }
                break;
        }
    };
    var ref1 = (0,react.useState)(null), defaultSearchOptions = ref1[0], setDefaultSearchOptions = ref1[1];
    (0,react.useEffect)(function() {
        (0,client/* getSearchDefaultOptionsAction */.cG)(pageId, window.location.pathname).then(function(response) {
            setDefaultSearchOptions(response.options);
            if (response.defaultLocationValue != undefined) {
                setSelectedSearchLocation(response.defaultLocationValue);
            } else {
                var customOption = {
                    value: customSearch,
                    label: customSearch
                };
                if (customOption.value != null) {
                    setSelectedSearchLocation(customOption);
                }
            }
        });
    }, [
        pageId
    ]);
    var loadSearchOptions = function(inputValue, callback) {
        (0,client/* loadSearchOptionsAction */.gV)(pageId, inputValue, callback);
    };
    var topSearch = function(searchLocation) {
        var location_val = searchLocation != null ? searchLocation.value : searchLocation;
        var location_data = location_val != null ? location_val.split("_") : null;
        var location_type = location_data != null ? location_data[0] : null;
        switch(location_type){
            case "destination":
                location.href = window.location.origin + searchLocation.slug;
                break;
            case "location":
                location.href = window.location.origin + searchLocation.slug;
                break;
            case "property":
                location.href = window.location.origin + searchLocation.slug;
                break;
            default:
                location.href = window.location.origin + "/properties/search/?search=" + location_val;
                break;
        }
    };
    var topSearchHandler = function(event) {
        event.preventDefault();
        topSearch(selectedSearchLocation);
    };
    // useEffect( () => {
    //   const keyEnter = event => {
    //     if ( event.key === 'Enter' ) {
    //       topSearch( selectedSearchLocation )
    //       // console.log( "enter pressed" )
    //       event.preventDefault()
    //     }
    //   }
    //
    //   document.addEventListener( 'keypress', keyEnter )
    // }, [selectedSearchLocation])
    // const [state, setState] = useState(false)
    var showGuestAreaLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_guests_area_show") == 1;
    });
    var guestAreaLinkTitle = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_guests_area_link_title");
    });
    var showOwnerAreaLink = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_owners_area_show") == 1;
    });
    var ownerAreaLinkTitle = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_owners_area_link_title");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showGuestAreaLink || showOwnerAreaLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "cursor-pointer nav-item me-0 ms-0 position-relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                id: "links-icon",
                                href: "#/",
                                className: "dropdown-toggle d-flex align-items-center",
                                "aria-label": "links",
                                title: "links",
                                "data-bs-toggle": "dropdown",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "links"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faUser */.ILF,
                                        size: "2x"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "dropdown-menu ",
                                style: {
                                    transform: "translate(-50%, 0)",
                                    left: "50%"
                                },
                                children: [
                                    showOwnerAreaLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "menu-icon",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "https://owners.loggia.gr/en/" + pageId + "/login",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: pro_solid_svg_icons/* faUserTie */.Cv1
                                                    }),
                                                    "\xa0",
                                                    Checkers/* default.isValidString */.Z.isValidString(guestAreaLinkTitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: guestAreaLinkTitle
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: "Owner's area"
                                                    })
                                                ]
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    showGuestAreaLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "menu-icon",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "https://guests.loggia.gr/en/" + pageId + "/login",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: pro_solid_svg_icons/* faPlane */.wKO
                                                    }),
                                                    "\xa0",
                                                    Checkers/* default.isValidString */.Z.isValidString(guestAreaLinkTitle) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: guestAreaLinkTitle
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: "Traveller's area"
                                                    })
                                                ]
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            })
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "nav-item me-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    id: "quick_search",
                    onSubmit: function(event) {
                        return topSearchHandler(event);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "search-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "search-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.Z, {
                                            noOptionsMessage: function() {
                                                return "nothing found";
                                            },
                                            loadingMessage: function() {
                                                return "searching...";
                                            },
                                            cacheOptions: false,
                                            defaultOptions: defaultSearchOptions,
                                            loadOptions: loadSearchOptions,
                                            onChange: handleInputChange,
                                            // // defaultValue={defaultLocationValue}
                                            value: selectedSearchLocation,
                                            className: "SearchBar-Form__form-group-select",
                                            id: "location_property",
                                            name: "location_property",
                                            inputId: "searchright",
                                            instanceId: "location_property",
                                            isSearchable: true,
                                            formatCreateLabel: function(inputValue) {
                                                return "Search for " + inputValue;
                                            },
                                            options: props.options,
                                            // styles={props.customStyles}
                                            placeholder: "Where are you going",
                                            blurInputOnSelect: true,
                                            menuPlacement: "bottom",
                                            components: {
                                                DropdownIndicator: function() {
                                                    return null;
                                                },
                                                IndicatorSeparator: function() {
                                                    return null;
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "search-btn pull-right",
                                            form: "quick_search",
                                            onClick: function(event) {
                                                return topSearchHandler(event);
                                            },
                                            "aria-label": "Search",
                                            type: "submit",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                size: "2x",
                                                icon: pro_light_svg_icons/* faMagnifyingGlass */.Y$T
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "search-backdrop",
                                    onClick: toggleTopSearch
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: "button searchbutton nav-link d-flex align-items-center search-label",
                            onClick: toggleTopSearch,
                            htmlFor: "searchright",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: "Search"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    size: "2x",
                                    icon: pro_light_svg_icons/* faMagnifyingGlass */.Y$T
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/header/types/HeaderDefault.tsx











var HeaderLogo = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 41306));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41306)
            ];
        }
    },
    ssr: true
});
var HeaderNavigation = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 44818));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44818)
            ];
        }
    },
    ssr: true
});
var ContactIcons = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 38530));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38530)
            ];
        }
    },
    ssr: true
});
function HeaderDefault(props) {
    var showSearch = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_show_menu_search_icon") == 1;
    });
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var handleShow = function() {
        setShow(true);
    };
    var handleHide = function() {
        setShow(false);
        return false;
    };
    var showMenuItemsInBurger = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_items_in_burger");
    });
    var navbarModeClass = props.navbarModeClass;
    var useRedirectUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "useRedirectUrl");
    });
    var homePageUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "logoUrl");
    });
    var homepageUrl = Checkers/* default.isValidString */.Z.isValidString((0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl)) ? (0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl) : "#";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                ref: props.setHeaderDiv,
                className: "header Header ".concat(navbarModeClass, " border-0 px-0 mb-0"),
                "data-builder-header": "different",
                style: {
                    height: "auto",
                    zIndex: props.zIndex > 0 ? props.zIndex : 99999
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: Checkers/* default.isValidString */.Z.isValidString(props.containerClass) ? props.containerClass : "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: homepageUrl,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "navbar-brand d-flex flex-row justify-content-start col-auto",
                                title: "logo",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLogo, {
                                    navbarModeClass: navbarModeClass,
                                    logoProps: props.logoProps,
                                    pageTitle: props.pageTitle
                                })
                            })
                        }),
                        props.hasOwnProperty("contactIcons") && props.contactIcons != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "minimized-partials navbar-nav d-flex flex-row justify-content-end ms-auto mb-2 mb-md-0 hidden-xs hidden-sm hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactIcons, {
                                contactIcons: props.contactIcons
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (showMenuItemsInBurger == "1" ? "d-flex navbar-toggle-collapse " : "d-none") + " w-100 ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "navbar-nav flex-row justify-content-end align-items-center ms-auto mb-2 mb-md-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactIcons, {
                                    contactIcons: props.contactIcons
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (showMenuItemsInBurger == "1" ? "d-none" : " navbar-toggle-collapse") + "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "navbar-nav flex-row justify-content-end align-items-center ms-auto mb-2 mb-md-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavigation, {
                                    referer: props.referer,
                                    menu: props.menu,
                                    partials: props.partials,
                                    headerPartialBook: true,
                                    modalDropdownClass: null,
                                    contactIcons: props.hasOwnProperty("contactIcons") ? props.contactIcons : null,
                                    handleHide: handleHide
                                })
                            })
                        }),
                        showSearch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "search-wrapper",
                                className: "d-flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "navbar-nav flex-row justify-content-end align-items-center ms-auto mb-2 mb-md-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon, {})
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: "test navbar-toggle collapsed border-0 " + (showMenuItemsInBurger == "1" ? "d-inline-block" : "visible-xs visible-sm"),
                            "aria-expanded": "false",
                            onClick: handleShow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: "Toggle navigation"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: props.faGripLines,
                                    size: "2x"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderCustomModal, {
                modalName: "side_menu",
                className: "Modal-Header slide-right",
                modalSize: "lg",
                closeModal: handleHide,
                showModal: show,
                setShowModal: setShow,
                modalBodyClass: "Modal__body navbar-menu d-flex flex-column justify-content-between padding-0",
                falTimes: props.falTimes,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "navbar-nav justify-content-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavigation, {
                            referer: props.referer,
                            menu: props.menu,
                            partials: props.partials,
                            headerPartialBook: false,
                            modalDropdownClass: "shadow-none position-relative mt-1 ps-2 pe-2 w-100",
                            contactIcons: null,
                            menuItemDisableWrap: true,
                            handleHide: handleHide
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "minimized-partials navbar-nav justify-content-start d-flex flex-column mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoSsr/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavigation, {
                                    referer: props.referer,
                                    menu: props.menu,
                                    partials: props.partials,
                                    modalPartials: true,
                                    contactIcons: null,
                                    menuItemDisableWrap: true,
                                    handleHide: handleHide
                                }),
                                props.hasOwnProperty("contactIcons") && props.contactIcons != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "Contact-Icons mt-1 mb-1 me-0 d-xs-flex d-sm-flex flex-row hidden",
                                    style: {
                                        margin: "5px 25px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactIcons, {
                                        contactIcons: props.contactIcons,
                                        modalDropdownClass: "shadow position-fixed mb-3 ps-2 pe-2 w-auto",
                                        side: "right"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/header/logo/HeaderLogo.tsx
var logo_HeaderLogo = __webpack_require__(41306);
// EXTERNAL MODULE: ./components/header/logo/HeaderLogoAltMode.tsx
var HeaderLogoAltMode = __webpack_require__(27515);
// EXTERNAL MODULE: ./components/header/menu/HeaderNavigation.tsx + 2 modules
var menu_HeaderNavigation = __webpack_require__(44818);
// EXTERNAL MODULE: ./components/header/partials/ContactIcons.tsx + 2 modules
var partials_ContactIcons = __webpack_require__(38530);
;// CONCATENATED MODULE: ./components/header/types/HeaderTypeFour.tsx













function HeaderTypeFour(props) {
    // useEffect(() =>{
    //   console.log("props.apps", props.apps)
    // })
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var handleShow = function() {
        setShow(true);
    };
    var handleHide = function() {
        setShow(false);
    };
    var useRedirectUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "useRedirectUrl");
    });
    var homePageUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "logoUrl");
    });
    var homepageUrl = Checkers/* default.isValidString */.Z.isValidString((0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl)) ? (0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl) : "#";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                ref: props.setHeaderDiv,
                className: "header-centered Header Header-Centered ".concat(props.navbarModeClass, " flex-row h-auto"),
                "data-pages": props.resizeClass != "" ? "header" : "",
                "data-builder-header": "centered",
                "data-pages-header": props.resizeClass != "" ? "autoresize" : "",
                "data-pages-resize-class": props.resizeClass,
                style: {
                    zIndex: props.zIndex > 0 ? props.zIndex : 10
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: Checkers/* default.isValidString */.Z.isValidString(props.containerClass) ? props.containerClass : "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row align-items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "navbar-nav flex-row col-5 justify-content-start invisible h-0",
                                "data-builder-left-nav": true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                    referer: props.referer,
                                    menu: props.menu,
                                    partials: props.partials,
                                    headerPartials: false,
                                    headerPartialBook: false,
                                    modalDropdownClass: null,
                                    handleHide: handleHide
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "nav flex-row col-12 col-md-2 justify-content-center",
                                "data-builder-center-logo": true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: "navbar-toggle collapsed border-0 hidden me-auto ms-4",
                                        "aria-expanded": "false",
                                        onClick: handleShow,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "Toggle navigation"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: props.faGripLines,
                                                size: "2x"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: homepageUrl,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "navbar-brand py-1 px-0",
                                            title: "logo",
                                            children: props.bgTransparent == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLogoAltMode["default"], {
                                                app: props.app,
                                                navbarModeClass: props.navbarModeClass,
                                                resizeClass: props.resizeClass,
                                                logoProps: props.logoProps,
                                                pageTitle: props.pageTitle
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_HeaderLogo["default"], {
                                                navbarModeClass: props.navbarModeClass,
                                                resizeClass: props.resizeClass,
                                                logoProps: props.logoProps,
                                                pageTitle: props.pageTitle
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "navbar-nav flex-row col-5 justify-content-end invisible h-0",
                                "data-builder-right-nav": true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                        referer: props.referer,
                                        menu: null,
                                        partials: props.partials,
                                        headerPartialBook: true,
                                        modalDropdownClass: null,
                                        contactIcons: null,
                                        handleHide: handleHide
                                    }),
                                    props.hasOwnProperty("contactIcons") ? props.contactIcons != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_ContactIcons["default"], {
                                        contactIcons: props.contactIcons
                                    }) : "" : ""
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderCustomModal, {
                modalName: "side_menu",
                className: "Modal-Header slide-left",
                modalSize: "lg",
                closeModal: handleHide,
                showModal: show,
                setShowModal: setShow,
                modalBodyClass: "Modal__body navbar-menu d-flex flex-column justify-content-between padding-0",
                falTimes: props.falTimes,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "navbar-nav justify-content-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                            referer: props.referer,
                            menu: props.menu,
                            partials: props.partials,
                            headerPartialBook: false,
                            modalDropdownClass: "shadow-none position-relative mt-1 ps-2 pe-2 w-100",
                            contactIcons: null,
                            menuItemDisableWrap: true,
                            handleHide: handleHide
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "navbar-nav justify-content-start mb-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                referer: props.referer,
                                menu: null,
                                partials: props.partials,
                                contactIcons: null,
                                menuItemDisableWrap: true,
                                handleHide: handleHide
                            }),
                            props.hasOwnProperty("contactIcons") && props.contactIcons != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "Contact-Icons mt-1 mb-1 ms-0 d-xs-flex d-sm-flex flex-row",
                                style: {
                                    margin: "5px 25px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_ContactIcons["default"], {
                                    contactIcons: props.contactIcons,
                                    modalDropdownClass: "shadow position-fixed mb-3 ps-2 pe-2 w-auto",
                                    side: "left"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/header/types/HeaderTypeOne.tsx














function HeaderTypeOne(props) {
    var showSearch = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_show_menu_search_icon") == 1;
    });
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var handleShow = function() {
        setShow(true);
    };
    var handleHide = function() {
        setShow(false);
    };
    var showMenuItemsInBurger = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_menu_items_in_burger");
    });
    var useRedirectUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "useRedirectUrl");
    });
    var homePageUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "logoUrl");
    });
    var homepageUrl = Checkers/* default.isValidString */.Z.isValidString((0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl)) ? (0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl) : "#";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                ref: props.setHeaderDiv,
                className: "test Header navbar " + props.navbarModeClass + props.textColor + " flex-nowrap border-0 px-0 mb-0",
                "data-pages": props.resizeClass != "" ? "header" : "",
                "data-builder-header": "different",
                "data-pages-header": props.resizeClass != "" ? "autoresize" : "",
                "data-pages-resize-class": props.resizeClass,
                style: {
                    height: "auto",
                    zIndex: props.zIndex > 0 ? props.zIndex : 1023
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "container",
                    className: Checkers/* default.isValidString */.Z.isValidString(props.containerClass) ? props.containerClass : "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: homepageUrl,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "navbar-brand d-flex flex-row justify-content-start py-0 px-0",
                                title: "logo",
                                children: props.headerProps.builder_header_mode == "transparent" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLogoAltMode["default"], {
                                        app: props.app,
                                        navbarModeClass: props.navbarModeClass,
                                        resizeClass: props.resizeClass,
                                        logoProps: props.logoProps,
                                        pageTitle: props.pageTitle
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_HeaderLogo["default"], {
                                    navbarModeClass: props.navbarModeClass,
                                    resizeClass: props.resizeClass,
                                    logoProps: props.logoProps,
                                    pageTitle: props.pageTitle
                                })
                            })
                        }),
                        props.hasOwnProperty("contactIcons") ? props.contactIcons != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "minimized-partials navbar-nav d-flex flex-row justify-content-end ms-auto mb-2 mb-md-0 hidden-xs hidden-sm hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_ContactIcons["default"], {
                                contactIcons: props.contactIcons
                            })
                        }) : "" : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (showMenuItemsInBurger == "1" ? "d-flex  navbar-toggle-collapse" : "d-none") + " w-100 ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "navbar-nav flex-row justify-content-end align-items-center ms-auto mb-2 mb-md-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_ContactIcons["default"], {
                                    contactIcons: props.contactIcons
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (showMenuItemsInBurger == "1" ? "d-none" : " navbar-toggle-collapse") + " ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "navbar-nav flex-row justify-content-end align-items-center ms-auto mb-2 mb-md-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                    referer: props.referer,
                                    menu: props.menu,
                                    partials: props.partials,
                                    headerPartialBook: true,
                                    modalDropdownClass: null,
                                    contactIcons: props.hasOwnProperty("contactIcons") ? props.contactIcons : null,
                                    handleHide: handleHide
                                })
                            })
                        }),
                        showSearch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "navbar-nav flex-row justify-content-end align-items-center ms-auto mb-2 mb-md-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon, {})
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: "τεστ-2 navbar-toggle collapsed border-0 " + (showMenuItemsInBurger == "1" ? "d-inline-block" : "visible-xs visible-sm"),
                            "aria-expanded": "false",
                            onClick: handleShow,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: "Toggle navigation"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: props.faGripLines,
                                    size: "2x"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderCustomModal, {
                modalName: "side_menu",
                className: "Modal-Header slide-right",
                modalSize: "lg",
                closeModal: handleHide,
                showModal: show,
                setShowModal: setShow,
                modalBodyClass: "Modal__body navbar-menu d-flex flex-column justify-content-between padding-0",
                falTimes: props.falTimes,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "navbar-nav justify-content-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                            referer: props.referer,
                            menu: props.menu,
                            partials: props.partials,
                            headerPartialBook: false,
                            modalDropdownClass: "shadow-none position-relative mt-1 ps-2 pe-2 w-100",
                            contactIcons: null,
                            menuItemDisableWrap: true,
                            handleHide: handleHide
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "minimized-partials navbar-nav justify-content-start d-flex flex-column mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoSsr/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                    referer: props.referer,
                                    menu: props.menu,
                                    partials: props.partials,
                                    modalPartials: true,
                                    contactIcons: null,
                                    menuItemDisableWrap: true,
                                    handleHide: handleHide
                                }),
                                props.hasOwnProperty("contactIcons") && props.contactIcons != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "Contact-Icons mt-1 mb-1 me-0 d-xs-flex d-sm-flex flex-row",
                                    style: {
                                        margin: "5px 25px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_ContactIcons["default"], {
                                        contactIcons: props.contactIcons,
                                        modalDropdownClass: "shadow position-fixed mb-3 ps-2 pe-2 w-auto",
                                        side: "right"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/header/types/HeaderTypeThree.tsx










var HeaderTypeThree_HeaderLogo = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 41306));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41306)
            ];
        }
    },
    ssr: true
});
var HeaderTypeThree_HeaderLogoAltMode = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 27515));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27515)
            ];
        }
    },
    ssr: true
});
var HeaderTypeThree_HeaderNavigation = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 44818));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44818)
            ];
        }
    },
    ssr: true
});
var HeaderTypeThree_ContactIcons = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 38530));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38530)
            ];
        }
    },
    ssr: true
});
function HeaderTypeThree(props) {
    // useEffect(() =>{
    //   console.log("props.apps", props.apps)
    // })
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var handleShow = function() {
        setShow(true);
    };
    var handleHide = function() {
        setShow(false);
    };
    var useRedirectUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "useRedirectUrl");
    });
    var homePageUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "logoUrl");
    });
    var homepageUrl = Checkers/* default.isValidString */.Z.isValidString((0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl)) ? (0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl) : "#";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                ref: props.setHeaderDiv,
                className: "Header ".concat(props.navbarModeClass, " d-flex flex-row align-items-center"),
                "data-pages": props.resizeClass != "" ? "header" : "",
                "data-builder-header": "minimized",
                "data-pages-header": props.resizeClass != "" ? "autoresize" : "",
                "data-pages-resize-class": props.resizeClass,
                style: {
                    height: "auto",
                    zIndex: props.zIndex > 0 ? props.zIndex : 10
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: Checkers/* default.isValidString */.Z.isValidString(props.containerClass) ? props.containerClass : "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex flex-row-reverse flex-md-row justify-content-between nav w-100",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: "navbar-toggle collapsed border-0 me-md-auto visible",
                                "aria-expanded": "false",
                                onClick: handleShow,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Toggle navigation"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: props.faGripLines,
                                        size: "2x"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: homepageUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "navbar-brand me-md-auto py-1 px-0",
                                    title: "logo",
                                    children: props.bgTransparent == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeThree_HeaderLogoAltMode, {
                                        app: props.app,
                                        navbarModeClass: props.navbarModeClass,
                                        resizeClass: props.resizeClass,
                                        logoProps: props.logoProps,
                                        pageTitle: props.pageTitle
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeThree_HeaderLogo, {
                                        navbarModeClass: props.navbarModeClass,
                                        resizeClass: props.resizeClass,
                                        logoProps: props.logoProps,
                                        pageTitle: props.pageTitle
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderCustomModal, {
                modalName: "side_menu",
                className: "Modal-Header slide-left",
                modalSize: "lg",
                closeModal: handleHide,
                showModal: show,
                setShowModal: setShow,
                modalBodyClass: "Modal__body navbar-menu padding-0 d-flex flex-column justify-content-between",
                falTimes: props.falTimes,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "navbar-nav justify-content-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeThree_HeaderNavigation, {
                            referer: props.referer,
                            menu: props.menu,
                            partials: props.partials,
                            headerPartialBook: false,
                            modalDropdownClass: "shadow-none position-relative mt-1 ps-2 pe-2 w-100",
                            contactIcons: null,
                            menuItemDisableWrap: true,
                            handleHide: handleHide
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "navbar-nav justify-content-start mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoSsr/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeThree_HeaderNavigation, {
                                    referer: props.referer,
                                    menu: props.menu,
                                    partials: props.partials,
                                    modalPartials: true,
                                    contactIcons: null,
                                    menuItemDisableWrap: true,
                                    handleHide: handleHide
                                }),
                                props.hasOwnProperty("contactIcons") && props.contactIcons != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "Contact-Icons mt-1 mb-1 ms-0 d-xs-flex d-sm-flex flex-row",
                                    style: {
                                        margin: "5px 25px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeThree_ContactIcons, {
                                        contactIcons: props.contactIcons,
                                        modalDropdownClass: "shadow position-fixed mb-3 ps-2 pe-2 w-auto",
                                        side: "left"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/header/types/HeaderTypeTwo.tsx













function HeaderTypeTwo(props) {
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var handleShow = function() {
        setShow(true);
    };
    var handleHide = function() {
        setShow(false);
    };
    var ul_class = props.property ? "nav inner navbar-nav my-2 d-flex flex-row justify-content-end align-items-center my-md-0" : "nav inner navbar-nav my-2 d-flex flex-row justify-content-end align-items-center my-md-0 hidden-xs hidden-sm hidden";
    var li_class = props.property ? " hidden-xs hidden-sm" : "";
    props.logoProps.logoMode = props.navbarModeClass.match("Header-Dark");
    var useRedirectUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "useRedirectUrl");
    });
    var homePageUrl = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "logoUrl");
    });
    var homepageUrl = Checkers/* default.isValidString */.Z.isValidString((0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl)) ? (0,MethodHelper/* getHomepageUrl */.Ir)(props.referer, useRedirectUrl, homePageUrl) : "#";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: "header-one Header Header-Double ".concat(props.navbarModeClass, " px-3 py-2 border-bottom"),
                "data-builder-header": "double",
                "data-builder-property": props.property,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: Checkers/* default.isValidString */.Z.isValidString(props.containerClass) ? props.containerClass : "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex flex-wrap align-items-center justify-content-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: homepageUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "d-flex align-items-center my-1 text-white text-decoration-none",
                                    title: "logo",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_HeaderLogo["default"], {
                                        navbarModeClass: props.navbarModeClass,
                                        resizeClass: props.resizeClass,
                                        logoProps: props.logoProps,
                                        pageTitle: props.pageTitle
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "navbar-toggle",
                                className: "d-flex flex-row justify-content-end align-items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: "navbar-toggle border-0 visible-xs visible-sm",
                                    "aria-expanded": "false",
                                    onClick: handleShow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Toggle navigation"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: props.faGripLines,
                                            size: "2x"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: ul_class,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "hint-text text-capitalize ".concat(li_class),
                                            href: "https://owners.loggia.gr/en/12/login",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: "Owner's Login"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "hint-text text-capitalize b-r p-r-20 ".concat(li_class),
                                            href: "https://guests.loggia.gr/en/12/login",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: "Traveler's Login"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: "tel:".concat(props.phone),
                                            className: "font-montserrat fs-13 ".concat(li_class),
                                            children: [
                                                props.phone,
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: pro_solid_svg_icons/* faPhone */.j1w,
                                                    className: "m-l-10"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "tel:".concat(props.phone),
                                            className: "font-montserrat fs-13",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faPhone */.j1w,
                                                className: "m-l-10 fs-18"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: "header-two Header ".concat(props.navbarTwoModeClass, " Header-Custom-Color Header-Sticky-Top flex-nowrap px-0 py-2 invisible hidden-xs hidden-sm h-0 padding-0"),
                style: {
                    zIndex: props.zIndex > 0 ? props.zIndex : 10
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(Checkers/* default.isValidString */.Z.isValidString(props.containerClass) ? props.containerClass : "container", " d-flex flex-row justify-content-center align-items-center"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "navbar-nav flex-row col-lg-auto me-lg-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                referer: props.referer,
                                menu: props.menu,
                                partials: props.partials,
                                headerPartials: false,
                                headerPartialBook: false,
                                modalDropdownClass: null,
                                handleHide: handleHide
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "navbar-nav flex-row justify-content-end",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                    referer: props.referer,
                                    menu: null,
                                    partials: props.partials,
                                    headerPartialBook: true,
                                    contactIcons: null,
                                    handleHide: handleHide
                                }),
                                props.hasOwnProperty("contactIcons") && props.contactIcons != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "mt-1 mb-1 ms-0 d-xs-flex d-sm-flex flex-row Contact-Icons",
                                    style: {
                                        margin: "5px 25px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_ContactIcons["default"], {
                                        contactIcons: props.contactIcons
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderCustomModal, {
                modalName: "side_menu",
                className: "Modal-Header Modal-Header-Double slide-right",
                modalSize: "lg",
                closeModal: handleHide,
                showModal: show,
                setShowModal: setShow,
                modalBodyClass: "Modal__body navbar-menu d-flex flex-column justify-content-between padding-0",
                falTimes: props.falTimes,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "navbar-nav justify-content-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                            referer: props.referer,
                            menu: props.menu,
                            partials: props.partials,
                            headerPartialBook: false,
                            modalDropdownClass: "shadow-none position-relative mt-1 ps-2 pe-2 w-100",
                            contactIcons: null,
                            menuItemDisableWrap: true,
                            handleHide: handleHide
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "navbar-nav justify-content-start mb-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_HeaderNavigation["default"], {
                                referer: props.referer,
                                menu: props.menu,
                                partials: props.partials,
                                modalPartials: true,
                                contactIcons: null,
                                menuItemDisableWrap: true,
                                handleHide: handleHide
                            }),
                            props.hasOwnProperty("contactIcons") && props.contactIcons != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "Contact-Icons mt-1 mb-1 ms-0 d-xs-flex d-sm-flex flex-row",
                                style: {
                                    margin: "5px 25px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_ContactIcons["default"], {
                                    contactIcons: props.contactIcons,
                                    modalDropdownClass: "shadow position-fixed mb-3 ps-2 pe-2 w-auto"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-regular-svg-icons/faBars.js
var faBars = __webpack_require__(21954);
;// CONCATENATED MODULE: ./components/Header.tsx














function Header(props) {
    var menu = props.navigation != undefined && props.navigation.hasOwnProperty("menu") ? props.navigation.menu : null;
    var partials = props.navigation != undefined && props.navigation.hasOwnProperty("partials") ? props.navigation.partials : null;
    var phone = props.head.location[0].phone;
    var containerClass = Checkers/* default.objChildExists */.Z.objChildExists(props, "containerClass") ? props.containerClass : null;
    var pageTitle = props.head.data.title;
    var contactIcons = function() {
        if (props.app.showContactIconsOnMenu) {
            return {
                phoneIcon: props.app.showPhoneIconOnMenu,
                chatIcon: props.app.showChatIconOnMenu,
                mailIcon: props.app.showMailIconOnMenu,
                phoneIconData: props.app.menuPhoneIconData,
                chatIconData: props.app.menuChatIconData,
                mailIconData: props.app.menuMailIconData
            };
        }
        return null;
    };
    var app = props.app;
    var ref = (0,react.useState)(null), headerDiv = ref[0], setHeaderDiv = ref[1];
    var ref1 = (0,react.useState)(null), referer = ref1[0], setReferer = ref1[1];
    var property = props.hasOwnProperty("isHomepage") ? !props.isHomepage : true;
    (0,react.useEffect)(function() {
        if (window !== undefined && document !== undefined) {
            setReferer(window.location.origin + "/");
            if (!property && headerDiv && props.builder.builder_header_type != "double") {
                var headerTop = headerDiv.getBoundingClientRect().top;
                window.addEventListener("scroll", function() {
                    if (this.scrollY > headerTop) {
                        headerDiv.classList.add("Header-Sticky-Top");
                        headerDiv.classList.remove("Header-Sticky-Top-Not");
                    } else {
                        headerDiv.classList.remove("Header-Sticky-Top");
                        headerDiv.classList.add("Header-Sticky-Top-Not");
                    }
                });
                window.addEventListener("load", function() {
                    if (this.scrollY > headerTop) {
                        headerDiv.classList.add("Header-Sticky-Top");
                        headerDiv.classList.remove("Header-Sticky-Top-Not");
                    } else {
                        headerDiv.classList.remove("Header-Sticky-Top");
                        headerDiv.classList.add("Header-Sticky-Top-Not");
                    }
                });
            }
        }
    }, [
        headerDiv,
        property,
        props.builder.builder_header_type,
        referer
    ]);
    var menuIconAlt = (0,es/* useSelector */.v9)(function(state) {
        return Checkers/* default.valueToBoolean */.Z.valueToBoolean((0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_menu_alt_icon"));
    });
    var navbarModeClass = "";
    var navbarTwoModeClass = "";
    var resizeClass = "";
    var faGripLines = null;
    faGripLines = menuIconAlt ? faBars/* faBars */.xi : pro_solid_svg_icons/* faGripLines */.hx$;
    if (app.designMode == true) {
        navbarModeClass = "Header-Dark";
    } else {
        navbarModeClass = "Header-Light";
    }
    // console.log("props.builder.builder_header_type", props.builder.builder_header_type)
    if (props.builder.builder_header_type != "default") {
        if (props.builder.builder_header_mode == "transparent") {
            if (Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_first_state_mode)) {
                navbarModeClass = "Header-Dark";
            } else {
                navbarModeClass = "Header-Light";
            }
            if (Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_second_state_mode)) {
                resizeClass += "Header-Dark border-bottom ";
            } else {
                resizeClass += "Header-Light border-bottom ";
            }
            if (Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_color)) {
                resizeClass += " Header-Custom-Color ";
            }
        } else {
            if (Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_first_state_mode)) {
                navbarModeClass = "Header-Dark";
            } else {
                navbarModeClass = "Header-Light";
            }
            if (Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_color)) {
                navbarModeClass += " Header-Custom-Color ";
            }
        }
        if (props.builder.builder_header_type == "double") {
            if (Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_one_mode)) {
                navbarModeClass = "Header-Dark";
            } else {
                navbarModeClass = "Header-Light";
            }
            if (Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_two_mode)) {
                navbarTwoModeClass = "Header-Dark";
            } else {
                navbarTwoModeClass = "Header-Light";
            }
            if (Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_logo_mode)) {}
        }
        if (!property && props.builder.builder_header_mode == "transparent") {
            navbarModeClass += "-Transparent fixed-top ";
        } else {
            if (Checkers/* default.isValidString */.Z.isValidString(resizeClass)) navbarModeClass = resizeClass;
            resizeClass = "";
        }
        if (property) {
            navbarModeClass += " ";
        }
    }
    switch(props.builder.builder_header_type){
        case "different":
        case "double":
        case "minimized":
        case "centered":
            if (!Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold)) {
                navbarModeClass += " no-bold ";
                faGripLines = menuIconAlt ? faBars/* faBars */.xi : pro_solid_svg_icons/* faGripLines */.hx$;
            }
            break;
    }
    var headerProps = {
        builder_header_type: props.builder.builder_header_type,
        builder_header_mode: props.builder.builder_header_mode,
        builder_header_menu_bold: props.builder.builder_header_menu_bold,
        builder_header_one_mode: props.builder.builder_header_one_mode,
        builder_header_first_state_mode: props.builder.builder_header_first_state_mode,
        builder_header_second_state_mode: props.builder.builder_header_second_state_mode,
        builder_header_color: props.builder.builder_header_color,
        builder_header_logo_mode: props.builder.builder_header_logo_mode,
        builder_header_menu_color: props.builder.builder_header_menu_color,
        builder_header_two_mode: props.builder.builder_header_two_mode
    };
    var logoProps = {
        logoLightOriginHeight: app.logoLightOriginHeight,
        logoLightOriginWidth: app.logoLightOriginWidth,
        logoDarkOriginHeight: app.logoDarkOriginHeight,
        logoDarkOriginWidth: app.logoDarkOriginWidth,
        logoLightHeigth: app.logoLightHeigth,
        logoLightHeigthAlt: app.logoLightHeigthAlt,
        logoDarkHeigth: app.logoDarkHeigth,
        logoDarkHeigthAlt: app.logoDarkHeigthAlt,
        logoLight: app.logoLight,
        logoDark: app.logoDark,
        logoMode: Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_type) && props.builder.builder_header_type != "default" ? Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_logo_mode) : navbarModeClass.match("Header-Dark")
    };
    var stateForModal = props.builder.builder_header_type == "default" ? Checkers/* default.valueToBoolean */.Z.valueToBoolean(app.designMode) : props.builder.builder_header_type == "double" ? Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_one_mode) : props.builder.builder_header_mode == "transparent" ? Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_second_state_mode) : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_first_state_mode);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_color) && (0,jsx_runtime.jsx)((style_default()), {
                id: "7c5fa69cd2904e08",
                dynamic: [
                    props.builder.builder_header_color
                ],
                children: ".Header-Custom-Color{background-color:".concat(props.builder.builder_header_color, "!important}")
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "1f8fed18cf663150",
                dynamic: [
                    props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400,
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "color: " + props.builder.builder_header_menu_color + "!important" : "",
                    Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400,
                    props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400,
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "background-color: transparent" : "",
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "color: " + props.builder.builder_header_menu_color + "!important" : "",
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "border-color: " + props.builder.builder_header_menu_color + "!important" : ""
                ],
                children: ".Header.Header-Dark svg,.Header.Header-Light svg,.Header.Header-Dark .navbar-nav .nav-link,.Header.Header-Light .navbar-nav .nav-link,.Header.minimized.Header-Dark .navbar-nav .nav-link,.Header.minimized.Header-Light .navbar-nav .nav-link,.Header.minimized.Header-Light .navbar-nav .nav-link svg{font-weight:".concat(props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400, "!important;").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "color: " + props.builder.builder_header_menu_color + "!important" : "", ";}.Header .dropdown-menu>li>a{font-weight:").concat(Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400, "!important}.Header.Header-Dark .btn,.Header.Header-Light .btn,.Header.Header-Dark .btn:hover:not(.active),.Header.Header-Light .btn:hover:not(.active),.Header.minimized.Header-Dark .btn,.Header.minimized.Header-Light .btn,.Header.minimized.Header-Dark .btn:hover:not(.active),.Header.minimized.Header-Light .btn:hover:not(.active){font-weight:").concat(props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400, "!important;").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "background-color: transparent" : "", ";").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "color: " + props.builder.builder_header_menu_color + "!important" : "", ";").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? "border-color: " + props.builder.builder_header_menu_color + "!important" : "", ";}.Header.Header-Double.Header-Dark svg,.Header.Header-Double.Header-Dark .navbar-nav .nav-link{color:rgb(255,255,255)!important}.Header.Header-Double.Header-Light svg,.Header.Header-Double.Header-Light .navbar-nav .nav-link{color:rgb(0,0,0)!important}.Header.Header-Double.Header-Dark .btn,.Header.Header-Double.Header-Dark .btn:hover:not(.active){color:rgb(255,255,255)!important;border-color:rgb(255,255,255)!important}.Header.Header-Double.Header-Light .btn,.Header.Header-Double.Header-Light .btn:hover:not(.active){color:rgb(0,0,0)!important;border-color:rgb(0,0,0)!important}")
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "331909cb8b19d4f6",
                dynamic: [
                    props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400,
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_color) ? props.builder.builder_header_color : stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)",
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_color) ? props.builder.builder_header_color : stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)",
                    props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400,
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) || !!stateForModal ? "background-color: transparent" : "",
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? props.builder.builder_header_menu_color : stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)",
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? props.builder.builder_header_menu_color : stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)",
                    stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)",
                    stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)",
                    props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400,
                    Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? props.builder.builder_header_menu_color : stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)",
                    stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)"
                ],
                children: ".Modal-Header .modal-dialog .modal-content,.Modal-Header .modal-dialog .modal-content .Modal__body,.Modal-Header .modal-dialog .modal-content .Modal__body ul li ul.dropdown-menu{font-weight:".concat(props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400, "!important;background:").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_color) ? props.builder.builder_header_color : stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)", "!important;background-color:").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_color) ? props.builder.builder_header_color : stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)", "!important}.Modal-Header .modal-dialog .modal-content .Modal__body .btn,.Modal-Header .modal-dialog .modal-content .Modal__body .btn:hover:not(.active){font-weight:").concat(props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400, "!important;").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) || !!stateForModal ? "background-color: transparent" : "", ";color:").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? props.builder.builder_header_menu_color : stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)", "!important;border-color:").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? props.builder.builder_header_menu_color : stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)", "!important}.Modal-Header-Double .modal-dialog .modal-content,.Modal-Header-Double .modal-dialog .modal-content .Modal__body,.Modal-Header-Double .modal-dialog .modal-content .Modal__body ul li ul.dropdown-menu{background:").concat(stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)", "!important;background-color:").concat(stateForModal ? "rgba(0,0,0)" : "rgba(255,255,255)", "!important}.Modal-Header .modal-dialog .modal-content .Modal__header a,.Modal-Header .modal-dialog .modal-content .Modal__header button,.Modal-Header .modal-dialog .modal-content .Modal__header button svg,.Modal-Header .modal-dialog .modal-content .Modal__body ul li a,.Modal-Header .modal-dialog .modal-content .Modal__body ul li a.nav-link,.Modal-Header .modal-dialog .modal-content .Modal__body ul li svg,.Modal-Header .modal-dialog .modal-content .Modal__body ul li a svg{font-weight:").concat(props.builder.builder_header_type == "default" ? 600 : Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.builder.builder_header_menu_bold) ? 600 : 400, "!important;color:").concat(Checkers/* default.isValidString */.Z.isValidString(props.builder.builder_header_menu_color) ? props.builder.builder_header_menu_color : stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)", "!important}.Modal-Header-Double .modal-dialog .modal-content .Modal__header a,.Modal-Header-Double .modal-dialog .modal-content .Modal__header button,.Modal-Header-Double .modal-dialog .modal-content .Modal__header button svg,.Modal-Header-Double .modal-dialog .modal-content .Modal__body ul li a,.Modal-Header-Double .modal-dialog .modal-content .Modal__body ul li a.nav-link,.Modal-Header-Double .modal-dialog .modal-content .Modal__body ul li svg,.Modal-Header-Double .modal-dialog .modal-content .Modal__body ul li a svg{color:").concat(stateForModal ? "rgba(255,255,255)" : "rgba(0,0,0)", "!important}.Modal-Header .modal-dialog .modal-content .Modal__body .Contact-Icons ul.Contact-Icons__dropdown{-webkit-box-shadow:0 0 3px#ccc!important;-moz-box-shadow:0 0 3px#ccc!important;box-shadow:0 0 3px#ccc!important}")
            }),
            props.property && /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "\n          .Header.Header-Double,\n          .Header.Header-Sticky-Top{\n            position: initial !important;\n          }\n        "
            }),
            props.builder.builder_header_type == "different" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeOne, {
                app: app,
                containerClass: containerClass,
                falTimes: pro_light_svg_icons/* faTimes */.NBC,
                faGripLines: faGripLines,
                designMode: app.designMode,
                headerProps: headerProps,
                logoProps: logoProps,
                navbarModeClass: navbarModeClass,
                resizeClass: resizeClass,
                menu: menu,
                partials: partials,
                showBookButtonMenu: app.showBookButtonMenu,
                contactIcons: contactIcons(),
                referer: referer,
                zIndex: Checkers/* default.objChildExists */.Z.objChildExists(props, "zIndex") ? props.zIndex : 0,
                pageTitle: pageTitle,
                headerDiv: headerDiv,
                setHeaderDiv: setHeaderDiv
            }) : props.builder.builder_header_type == "double" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeTwo, {
                app: app,
                containerClass: containerClass,
                falTimes: pro_light_svg_icons/* faTimes */.NBC,
                faGripLines: faGripLines,
                designMode: props.designMode,
                headerProps: app,
                logoProps: logoProps,
                navbarModeClass: navbarModeClass,
                navbarTwoModeClass: navbarTwoModeClass,
                resizeClass: resizeClass,
                menu: menu,
                partials: partials,
                showBookButtonMenu: app.showBookButtonMenu,
                contactIcons: contactIcons(),
                phone: phone,
                property: property,
                referer: referer,
                zIndex: Checkers/* default.objChildExists */.Z.objChildExists(props, "zIndex") ? props.zIndex : 0,
                pageTitle: pageTitle
            }) : props.builder.builder_header_type == "minimized" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeThree, {
                app: app,
                containerClass: containerClass,
                falTimes: pro_light_svg_icons/* faTimes */.NBC,
                faGripLines: faGripLines,
                designMode: app.designMode,
                headerProps: headerProps,
                logoProps: logoProps,
                navbarModeClass: navbarModeClass,
                resizeClass: resizeClass,
                menu: menu,
                partials: partials,
                showBookButtonMenu: app.showBookButtonMenu,
                contactIcons: contactIcons(),
                referer: referer,
                zIndex: Checkers/* default.objChildExists */.Z.objChildExists(props, "zIndex") ? props.zIndex : 0,
                pageTitle: pageTitle,
                setHeaderDiv: setHeaderDiv
            }) : props.builder.builder_header_type == "centered" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTypeFour, {
                app: app,
                containerClass: containerClass,
                falTimes: pro_light_svg_icons/* faTimes */.NBC,
                faGripLines: faGripLines,
                designMode: app.designMode,
                headerProps: headerProps,
                logoProps: logoProps,
                navbarModeClass: navbarModeClass,
                resizeClass: resizeClass,
                menu: menu,
                partials: partials,
                showBookButtonMenu: app.showBookButtonMenu,
                contactIcons: contactIcons(),
                referer: referer,
                zIndex: Checkers/* default.objChildExists */.Z.objChildExists(props, "zIndex") ? props.zIndex : 0,
                pageTitle: pageTitle,
                setHeaderDiv: setHeaderDiv
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDefault, {
                app: app,
                containerClass: containerClass,
                falTimes: pro_light_svg_icons/* faTimes */.NBC,
                faGripLines: faGripLines,
                designMode: app.designMode,
                headerProps: headerProps,
                logoProps: logoProps,
                navbarModeClass: navbarModeClass,
                resizeClass: resizeClass,
                menu: menu,
                partials: partials,
                showBookButtonMenu: app.showBookButtonMenu,
                contactIcons: contactIcons(),
                referer: referer,
                zIndex: Checkers/* default.objChildExists */.Z.objChildExists(props, "zIndex") ? props.zIndex : 0,
                pageTitle: pageTitle,
                setHeaderDiv: setHeaderDiv
            })
        ]
    });
}


/***/ }),

/***/ 41306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HeaderLogo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53429);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83974);



function HeaderLogo(props) {
    var height = 0;
    var factor = 1;
    var logoProps = props.logoProps;
    if (logoProps.logoMode) {
        factor = logoProps.logoDarkOriginWidth / logoProps.logoDarkOriginHeight;
        if (logoProps.logoDarkHeigth != null && logoProps.logoDarkHeigth > 0) {
            height = logoProps.logoDarkHeigth;
        } else {
            height = 30;
        }
    } else {
        factor = logoProps.logoLightOriginWidth / logoProps.logoLightOriginHeight;
        if (logoProps.logoLightHeigth != null && logoProps.logoLightHeigth > 0) {
            height = logoProps.logoLightHeigth;
        } else {
            height = 30;
        }
    }
    var logoUrl = logoProps.logoMode ? logoProps.logoDark : logoProps.logoLight;
    var widthInit = height * factor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_2__/* ["default"].isValidString */ .Z.isValidString(logoUrl) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            loading: "eager",
            layout: "intrinsic",
            width: widthInit,
            height: height,
            className: "logo",
            src: logoUrl,
            alt: "logo_header",
            blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            className: logoProps.logoMode ? "text-white" : "text-black",
            children: props.pageTitle
        })
    });
}


/***/ }),

/***/ 27515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HeaderLogoAltMode; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83974);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31969);



function HeaderLogoAltMode(props) {
    var logo_height = 30;
    var logo_alt_height = 30;
    var logo_factor = 1;
    var logo_alt_factor = 1;
    var logoProps = props.logoProps;
    if (props.navbarModeClass.match("Header-Dark-Transparent")) {
        logo_factor = logoProps.logoDarkOriginWidth / logoProps.logoDarkOriginHeight;
        if (logoProps.logoDarkHeigth != null && logoProps.logoDarkHeigth > 0) {
            logo_height = logoProps.logoDarkHeigth;
        }
    } else {
        logo_factor = logoProps.logoLightOriginWidth / logoProps.logoLightOriginHeight;
        if (logoProps.logoLightHeigth != null && logoProps.logoLightHeigth > 0) {
            logo_height = logoProps.logoLightHeigth;
        }
    }
    if (logoProps.logoMode) {
        logo_alt_factor = logoProps.logoDarkOriginWidth / logoProps.logoDarkOriginHeight;
        if (logoProps.logoDarkHeigthAlt != null && logoProps.logoDarkHeigthAlt > 0) logo_alt_height = logoProps.logoDarkHeigthAlt;
    } else {
        logo_alt_factor = logoProps.logoLightOriginWidth / logoProps.logoLightOriginHeight;
        if (logoProps.logoLightHeigthAlt != null && logoProps.logoLightHeigthAlt > 0) logo_alt_height = logoProps.logoLightHeigthAlt;
    }
    var logo_widthInit = logo_height * logo_factor;
    var logo_alt_widthInit = logo_alt_height * logo_alt_factor;
    var logoUrl = function() {
        if (props.app.builder.builder_header_logo_mode_sticky == "0") {
            return logoProps.logoLight;
        }
        if (props.app.builder.builder_header_logo_mode_sticky == "1") {
            return logoProps.logoDark;
        }
        return props.navbarModeClass.match("Header-Dark-Transparent") ? logoProps.logoDark : logoProps.logoLight;
    };
    var logoAltUrl = logoProps.logoMode ? logoProps.logoDark : logoProps.logoLight;
    var isHomePage = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isHomepage"];
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            isHomePage == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidString */ .Z.isValidString(logoUrl()) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        width: logo_widthInit,
                        height: logo_height,
                        src: logoUrl(),
                        alt: "logo_alt_header",
                        className: "logo_header logo",
                        loading: "lazy"
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidString */ .Z.isValidString(logoAltUrl) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                width: logo_alt_widthInit,
                height: logo_alt_height,
                src: logoAltUrl,
                alt: "logo_alt_header",
                className: "logo_header  " + (isHomePage ? "alt logo" : "logo"),
                loading: "lazy"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidString */ .Z.isValidString(logoAltUrl) && !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidString */ .Z.isValidString(logoUrl()) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: logoProps.logoMode ? "text-white" : "text-black",
                    children: props.pageTitle
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        ]
    });
}


/***/ }),

/***/ 44818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HeaderNavigation; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/fontawesome-svg-core/index.mjs
var fontawesome_svg_core = __webpack_require__(95623);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/fontawesome-svg-core/styles.css
var styles = __webpack_require__(54197);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(87091);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(72976);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ./components/header/partials/ContactIcons.tsx + 2 modules
var ContactIcons = __webpack_require__(38530);
// EXTERNAL MODULE: ./components/header/partials/DropdownArrow.tsx
var DropdownArrow = __webpack_require__(75203);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
// EXTERNAL MODULE: ../../shared/node_modules/next/link.js
var next_link = __webpack_require__(75547);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/header/menu/HeaderMenu.tsx



fontawesome_svg_core/* config.autoAddCss */.vc.autoAddCss = false;










function HeaderMenu(props) {
    var menuItemDisableWrap = props.hasOwnProperty("menuItemDisableWrap") ? props.menuItemDisableWrap : false;
    var handleHide = props.hasOwnProperty("handleHide") ? props.handleHide : false;
    var textWrapClass = menuItemDisableWrap ? "" : "text-nowrap";
    var showMenuItems = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_header_show_menu_items");
    });
    var elRefs = (0,react.useRef)([]);
    (0,react.useEffect)(function() {
        if (document !== undefined && elRefs !== undefined) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = elRefs.current[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var elRef = _step.value;
                    elRef !== undefined && elRef.addEventListener("mouseenter", function() {
                        this.children[0].classList.add("show");
                        this.children[0].setAttribute("aria-extended", "true");
                        this.children[1].classList.add("show");
                    });
                    elRef !== undefined && elRef.addEventListener("mouseleave", function() {
                        this.children[0].classList.remove("show");
                        this.children[0].setAttribute("aria-extended", "false");
                        this.children[1].classList.remove("show");
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, [
        elRefs
    ]);
    var topLevelHref = function(menu, loggiaUrl) {
        if (menu.hasOwnProperty("redirectUrl")) {
            return menu.redirectUrl;
        }
        return loggiaUrl != null ? props.referer + loggiaUrl : menu.urlSlug != null ? props.referer + menu.urlSlug : "#";
    };
    var topLevelHrefBlank = function(menu, loggiaUrl) {
        if (menu.hasOwnProperty("redirectUrl")) {
            return true;
        }
        return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showMenuItems == "1" && Checkers/* default.isValidArray */.Z.isValidArray(props.menu) && props.menu.map(function(menu, key) {
                var loggiaUrl = menu.loggiaUrl;
                if (Checkers/* default.isValidString */.Z.isValidString(loggiaUrl) && loggiaUrl.startsWith("/")) {
                    loggiaUrl = loggiaUrl.substring(1);
                }
                var special_class = "";
                if (menu.special_class != undefined && menu.special_class.length > 0) {
                    special_class = menu.special_class;
                }
                return menu.title != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    ref: Checkers/* default.isValidArray */.Z.isValidArray(menu.entries) ? function(el) {
                        elRefs.current[key] = el;
                    } : undefined,
                    className: menu.entries != null ? "nav-item dropdown cursor-pointer" : "nav-item",
                    children: [
                        menu.hasOwnProperty("force_reload") && menu.force_reload ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                "aria-current": "page",
                                href: topLevelHref(menu, loggiaUrl),
                                className: special_class + " " + (menu.entries != null ? "d-flex nav-link dropdown-toggle " + textWrapClass : "nav-link test-111 " + textWrapClass),
                                children: [
                                    menu.title,
                                    Checkers/* default.isValidArray */.Z.isValidArray(menu.entries) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_solid_svg_icons/* faChevronDown */.ptq,
                                        className: "m-l-5 align-self-center",
                                        style: {
                                            fontSize: "10.5px"
                                        }
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: topLevelHrefBlank(menu, loggiaUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    target: "_blank",
                                    href: topLevelHref(menu, loggiaUrl),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: special_class + " " + (menu.entries != null ? "d-flex nav-link dropdown-toggle " + textWrapClass : "nav-link test-222 " + textWrapClass),
                                        "aria-current": "page",
                                        onClick: function() {
                                            if (handleHide != undefined) {
                                                handleHide();
                                            }
                                        },
                                        rel: "noreferrer noopener",
                                        children: [
                                            menu.title,
                                            Checkers/* default.isValidArray */.Z.isValidArray(menu.entries) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faChevronDown */.ptq,
                                                className: "m-l-5 align-self-center",
                                                style: {
                                                    fontSize: "10.5px"
                                                }
                                            })
                                        ]
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: topLevelHref(menu, loggiaUrl),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        "aria-current": "page",
                                        onClick: function() {
                                            if (handleHide != undefined) {
                                                handleHide();
                                            }
                                        },
                                        className: special_class + " " + (menu.entries != null ? "d-flex nav-link dropdown-toggle " + textWrapClass : "nav-link test-44444 " + textWrapClass),
                                        children: [
                                            menu.title,
                                            Checkers/* default.isValidArray */.Z.isValidArray(menu.entries) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: pro_solid_svg_icons/* faChevronDown */.ptq,
                                                className: "m-l-5 align-self-center",
                                                style: {
                                                    fontSize: "10.5px"
                                                }
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        Checkers/* default.isValidArray */.Z.isValidArray(menu.entries) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: props.modalDropdownClass != null ? "dropdown-menu dropdown-article-menu " + props.modalDropdownClass : "dropdown-menu dropdown-article-menu shadow " + (menu.entries.length > 10 ? "megamenu" : ""),
                            children: [
                                props.modalDropdownClass == null && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownArrow/* default */.Z, {}),
                                menu.entries.map(function(entry, key) {
                                    var loggiaUrl = entry.loggiaUrl;
                                    if (Checkers/* default.isValidString */.Z.isValidString(loggiaUrl) && loggiaUrl.startsWith("/")) {
                                        loggiaUrl = loggiaUrl.substring(1);
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: key == 0 ? "dropdown-ul-item mt-20px" : "dropdown-ul-item mt-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: Checkers/* default.isValidString */.Z.isValidString(entry.redirectUrl) ? entry.redirectUrl : loggiaUrl != null ? props.referer + loggiaUrl : entry.urlSlug != null ? props.referer + entry.urlSlug : "#",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "dropdown-item text-wrap ",
                                                onClick: function() {
                                                    if (handleHide != undefined) {
                                                        handleHide();
                                                    }
                                                },
                                                children: entry.title
                                            })
                                        })
                                    }, key);
                                })
                            ]
                        })
                    ]
                }, key) : "";
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactIcons["default"], {
                contactIcons: props.contactIcons
            }),
            props.partials !== null && props.partials.hasOwnProperty("book") === true ? props.partials.book != null && props.headerPartialBook == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "nav-item",
                dangerouslySetInnerHTML: {
                    __html: props.partials.book.title
                }
            }) : "" : "",
            props.partials !== null && props.partials.hasOwnProperty("lang") === true ? props.partials.lang != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: "nav-item dropdown cursor-pointer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "#",
                        id: props.modalDropdownClass != null ? "modal-lang" : "lang",
                        className: props.partials.lang.entries != null ? "d-flex nav-link lang-toggle" : "nav-link",
                        "aria-current": "page",
                        "aria-label": "lang",
                        title: "lang",
                        onClick: function() {
                            if (handleHide != undefined) {
                                handleHide();
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: pro_regular_svg_icons/* faLanguage */.BCn,
                            size: "2x"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: props.modalDropdownClass != null ? "dropdown-menu dropdown-lang-menu " + props.modalDropdownClass : "dropdown-menu dropdown-lang-menu shadow",
                        "aria-labelledby": props.modalDropdownClass != null ? "modal-lang" : "lang",
                        children: [
                            props.modalDropdownClass == null && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownArrow/* default */.Z, {}),
                            props.partials.lang.entries.map(function(entry, key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: key == 0 ? "dropdown-ul-item mt-20px" : "dropdown-ul-item mt-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: props.referer + entry.code,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "dropdown-item",
                                            onClick: function() {
                                                if (handleHide != undefined) {
                                                    handleHide();
                                                }
                                            },
                                            children: entry.name
                                        })
                                    })
                                }, key);
                            })
                        ]
                    })
                ]
            }) : "" : ""
        ]
    });
}

;// CONCATENATED MODULE: ./components/header/menu/HeaderPartials.tsx

function HeaderPartials(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.partials !== null && props.partials.hasOwnProperty("book") === true ? // eslint-disable-next-line react/jsx-key
        props.partials.book != undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: "nav-item",
            dangerouslySetInnerHTML: {
                __html: props.partials.book.title
            }
        }) : "" : ""
    });
}

;// CONCATENATED MODULE: ./components/header/menu/HeaderNavigation.tsx



function HeaderNavigation(props) {
    var menuItemDisableWrap = props.hasOwnProperty("menuItemDisableWrap") ? props.menuItemDisableWrap : false;
    var handleHide = props.hasOwnProperty("handleHide") ? props.handleHide : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.modalPartials == true || props.headerPartials == true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderPartials, {
            partials: props.partials
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMenu, {
            referer: props.referer,
            menu: props.menu,
            partials: props.partials,
            headerPartialBook: props.headerPartialBook,
            modalDropdownClass: props.modalDropdownClass,
            contactIcons: props.hasOwnProperty("contactIcons") ? props.contactIcons : null,
            menuItemDisableWrap: menuItemDisableWrap,
            handleHide: handleHide
        })
    });
}


/***/ }),

/***/ 38530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ContactIcons; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(76191);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(72976);
// EXTERNAL MODULE: ../../shared/node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(96350);
;// CONCATENATED MODULE: ./components/header/partials/ContactPhones.tsx

function ContactPhones(props) {
    return props.phoneIconData.split(",").map(function(phone, key) {
        return(// eslint-disable-next-line react/jsx-key
        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: key == 0 ? "dropdown-ul-item mt-20px" : "dropdown-ul-item mt-3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "dropdown-item text-wrap",
                href: phone.split(":").length > 1 ? "tel:" + phone.split(":")[1].replace(/\s+/g, "") : "tel:" + phone.replace(/\s+/g, ""),
                children: phone.split(":").length > 1 ? phone.split(":")[0].replace(/\s+/g, "") : phone.replace(/\s+/g, "")
            })
        }, key));
    });
}

;// CONCATENATED MODULE: ./components/header/partials/ContactWhatsApp.tsx

function ContactWhatsApp(props) {
    return props.phoneIconData.split(",").map(function(phone, key) {
        return(// eslint-disable-next-line react/jsx-key
        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: key == 0 ? "dropdown-ul-item mt-20px" : "dropdown-ul-item mt-3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "dropdown-item text-wrap",
                href: phone.split(":").length > 1 ? "https://wa.me/" + phone.split(":")[1].replace(/\s+/g, "").replace(/\+/g, "") : "https://wa.me/" + phone.replace(/\s+/g, "").replace(/\+/g, ""),
                children: phone.split(":").length > 1 ? phone.split(":")[0].replace(/\s+/g, "") : phone.replace(/\s+/g, "")
            })
        }, key));
    });
}

// EXTERNAL MODULE: ./components/header/partials/DropdownArrow.tsx
var DropdownArrow = __webpack_require__(75203);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
;// CONCATENATED MODULE: ./components/header/partials/ContactIcons.tsx











function ContactIcons(props) {
    var phoneRef = (0,react.useRef)();
    var chatRef = (0,react.useRef)();
    var mailRef = (0,react.useRef)();
    var addEventListeners = function(element) {
        if (element.children.length > 1) {
            element.addEventListener("mouseenter", function() {
                this.children[0].classList.add("show");
                this.children[0].setAttribute("aria-extended", "true");
                this.children[1].classList.add("show");
            });
            element.addEventListener("mouseleave", function() {
                this.children[0].classList.remove("show");
                this.children[0].setAttribute("aria-extended", "false");
                this.children[1].classList.remove("show");
            });
        }
    };
    (0,react.useEffect)(function() {
        if (document !== undefined) {
            if (phoneRef.current) {
                addEventListeners(phoneRef.current);
            }
            if (chatRef.current) {
                addEventListeners(chatRef.current);
            }
            if (mailRef.current) {
                addEventListeners(mailRef.current);
            }
        }
    }, []);
    var menuLabel = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_menu_label_start");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            props.contactIcons != null && Checkers/* default.isValidString */.Z.isValidString(menuLabel) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "nav-label nav-item",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "p-r-10 fs-16 bold nav-link pointer",
                        children: menuLabel
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            props.contactIcons != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    props.contactIcons.phoneIcon == true && props.contactIcons.phoneIconData != null && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        ref: phoneRef,
                        className: props.contactIcons.phoneIconData != null ? props.contactIcons.phoneIconData.split(",").length > 1 ? "nav-item dropdown cursor-pointer me-0" : "nav-item me-0" : "nav-item me-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                target: "_blank",
                                id: props.hasOwnProperty("modalDropdownClass") ? props.modalDropdownClass != null ? "modal-phone-icon" : "phone-icon" : "phone-icon",
                                href: props.contactIcons.phoneIconData != null ? props.contactIcons.phoneIconData.split(",").length > 1 ? "#" : "tel:" + props.contactIcons.phoneIconData.replace(/\s+/g, "") : "#",
                                className: "nav-link d-flex align-items-center",
                                "aria-label": "phone",
                                title: "phone",
                                rel: "noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "phone"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faPhone */.j1w,
                                        size: "2x"
                                    })
                                ]
                            }),
                            props.contactIcons.phoneIconData != null && props.contactIcons.phoneIconData.split(",").length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "Contact-Icons__dropdown \n                          ".concat(props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? "dropdown-menu dropdown-article-menu " + props.modalDropdownClass : "", " dropdown-menu dropdown-article-menu shadow\n                        "),
                                "aria-labelledby": props.hasOwnProperty("modalDropdownClass") ? props.modalDropdownClass != null ? "modal-phone-icon" : "phone-icon" : "phone-icon",
                                style: props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? {
                                    bottom: "80px",
                                    boxShadow: "0 0 10px #ccc!important"
                                } : undefined,
                                children: [
                                    props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        style: props.side == "right" ? {
                                            position: "fixed",
                                            bottom: "77.2px",
                                            left: "calc(25% - 16px)"
                                        } : {
                                            position: "fixed",
                                            bottom: "77.2px",
                                            right: "calc(78% - 25px)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faSortUp */.foy
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownArrow/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactPhones, {
                                        phoneIconData: props.contactIcons.phoneIconData
                                    })
                                ]
                            })
                        ]
                    }),
                    props.contactIcons.chatIcon == true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        ref: chatRef,
                        className: props.contactIcons.chatIconData != null ? props.contactIcons.chatIconData.split(",").length > 1 ? "nav-item dropdown cursor-pointer me-0" : "nav-item me-0" : "nav-item me-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                target: "_blank",
                                id: props.hasOwnProperty("modalDropdownClass") ? props.modalDropdownClass != null ? "modal-chat-icon" : "chat-icon" : "chat-icon",
                                href: props.contactIcons.chatIconData != null ? props.contactIcons.chatIconData.split(",").length > 1 ? "#" : "https://wa.me/" + props.contactIcons.chatIconData.replace(/\s+/g, "").replace(/\+/g, "") : "#",
                                className: "nav-link d-flex align-items-center",
                                "aria-label": "chat",
                                title: "chat",
                                rel: "noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "chat"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faComments */.lXL,
                                        size: "2x"
                                    })
                                ]
                            }),
                            props.contactIcons.chatIconData != null ? props.contactIcons.chatIconData.split(",").length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "Contact-Icons__dropdown \n                          ".concat(props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? "dropdown-menu dropdown-article-menu " + props.modalDropdownClass : "", " dropdown-menu dropdown-article-menu shadow\n                        "),
                                "aria-labelledby": props.hasOwnProperty("modalDropdownClass") ? props.modalDropdownClass != null ? "modal-chat-icon" : "chat-icon" : "chat-icon",
                                style: props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? {
                                    bottom: "80px",
                                    left: "20%",
                                    boxShadow: "0 0 3px #ccc"
                                } : undefined,
                                children: [
                                    props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        style: props.side == "right" ? {
                                            position: "fixed",
                                            bottom: "77.2px",
                                            right: "calc(40% - 16px)"
                                        } : {
                                            position: "fixed",
                                            bottom: "77.2px",
                                            right: "calc(50% - 18px)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faSortUp */.foy
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownArrow/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactWhatsApp, {
                                        phoneIconData: props.contactIcons.chatIconData
                                    })
                                ]
                            }) : "" : ""
                        ]
                    }) : "",
                    props.contactIcons.mailIcon == true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        ref: mailRef,
                        className: props.contactIcons.mailIconData != null ? props.contactIcons.mailIconData.split(",").length > 1 ? "nav-item dropdown cursor-pointer me-0" : "nav-item me-0" : "nav-item me-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                target: "_blank",
                                id: props.hasOwnProperty("modalDropdownClass") ? props.modalDropdownClass != null ? "modal-mail-icon" : "mail-icon" : "mail-icon",
                                href: props.contactIcons.mailIconData != null ? props.contactIcons.mailIconData.split(",").length > 1 ? "#" : "mailto:" + props.contactIcons.mailIconData.replace(/\s+/g, "") : "#",
                                className: "nav-link d-flex align-items-center",
                                "aria-label": "mail",
                                title: "mail",
                                rel: "noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "mail"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faEnvelope */.FU$,
                                        size: "2x"
                                    })
                                ]
                            }),
                            props.contactIcons.mailIconData != null ? props.contactIcons.mailIconData.split(",").length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "Contact-Icons__dropdown \n                          ".concat(props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? "dropdown-menu dropdown-article-menu " + props.modalDropdownClass : "", " dropdown-menu dropdown-article-menu shadow\n                        "),
                                "aria-labelledby": props.hasOwnProperty("modalDropdownClass") ? props.modalDropdownClass != null ? "modal-mail-icon" : "mail-icon" : "mail-icon",
                                style: props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? {
                                    bottom: "80px",
                                    left: "25%",
                                    boxShadow: "0 0 10px #ccc!important"
                                } : undefined,
                                children: [
                                    props.hasOwnProperty("modalDropdownClass") && props.modalDropdownClass != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        style: props.side == "right" ? {
                                            position: "fixed",
                                            bottom: "77.2px",
                                            right: "32px"
                                        } : {
                                            position: "fixed",
                                            bottom: "77.2px",
                                            right: "calc(23% - 7.2px)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faSortUp */.foy
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownArrow/* default */.Z, {}),
                                    props.contactIcons.mailIconData.split(",").map(function(mail, key) {
                                        return(// eslint-disable-next-line react/jsx-key
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: key == 0 ? "dropdown-ul-item mt-20px" : "dropdown-ul-item mt-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "dropdown-item text-wrap",
                                                target: "_blank",
                                                href: mail.split(":").length > 1 ? "mailto:" + mail.split(":")[1].replace(/\s+/g, "") : "mailto:" + mail.replace(/\s+/g, ""),
                                                rel: "noreferrer",
                                                children: mail.split(":").length > 1 ? mail.split(":")[0].replace(/\s+/g, "") : mail.replace(/\s+/g, "")
                                            })
                                        }, key));
                                    })
                                ]
                            }) : "" : ""
                        ]
                    }) : ""
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        ]
    });
}


/***/ }),

/***/ 75203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DropdownArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);

function DropdownArrow() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: "arrow",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            className: "position-absolute",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            x: "0px",
            y: "0px",
            width: "14px",
            height: "7px",
            viewBox: "0 0 14 7",
            enableBackground: "new 0 0 14 7",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                    fill: "#FFFFFF",
                    points: "0,0 7,7 14,0 14,7 0,7 "
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polyline", {
                    opacity: "0.1",
                    fill: "none",
                    stroke: "#231F20",
                    strokeMiterlimit: "10",
                    points: "0,0 7,7 14,0 "
                })
            ]
        })
    });
}


/***/ }),

/***/ 23158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AE": function() { return /* binding */ enableBookingBtn; },
/* harmony export */   "Ir": function() { return /* binding */ getHomepageUrl; },
/* harmony export */   "Nd": function() { return /* binding */ btnTextColor; },
/* harmony export */   "Yc": function() { return /* binding */ isDarkMode; },
/* harmony export */   "iP": function() { return /* binding */ useWindowSize; },
/* harmony export */   "iS": function() { return /* binding */ fetchBuilderSettingByKey; },
/* harmony export */   "kw": function() { return /* binding */ getPropertyPricingData; },
/* harmony export */   "n9": function() { return /* binding */ getPropertyViewType; },
/* harmony export */   "r$": function() { return /* binding */ getBedroomValue; },
/* harmony export */   "tC": function() { return /* binding */ updateBedrooms; },
/* harmony export */   "xA": function() { return /* binding */ getUnavailablePropertiesOpacity; },
/* harmony export */   "zP": function() { return /* binding */ textColor; }
/* harmony export */ });
/* unused harmony exports hexToRgb, initManifest, extendManifest, getBedroomPricingData, randomCoordinateFactor, queryStringToObject */
/* harmony import */ var _class_Checkers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83974);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* provided dependency */ var process = __webpack_require__(40476);


var hexToRgb = function(hex) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
            c = [
                c[0],
                c[0],
                c[1],
                c[1],
                c[2],
                c[2]
            ];
        }
        c = "0x" + c.join("");
        return [
            c >> 16 & 255,
            c >> 8 & 255,
            c & 255
        ].join(",");
    }
    return 0;
};
var initManifest = function(head, app, start_url) {
    var title = Checkers.objChildExists(head, "data") && Checkers.objChildExists(head.data, "title") ? head.data.title : "";
    var motto = Checkers.objChildExists(head, "data") && Checkers.objChildExists(head.data, "motto") ? head.data.motto : "";
    var designColor = Checkers.objChildExists(app, "designColor") ? app.designColor : "";
    if (Object.keys(head).length > 0) {
        return {
            "$schema": "https://json.schemastore.org/web-manifest-combined.json",
            "allOf": [
                {
                    "$ref": "https://json.schemastore.org/web-manifest.json"
                },
                {
                    "$ref": "https://json.schemastore.org/web-manifest-app-info.json"
                },
                {
                    "$ref": "https://json.schemastore.org/web-manifest-share-target.json"
                }
            ],
            "id": "/?source=pwa",
            "name": "".concat(title),
            "short_name": "".concat(title),
            "start_url": "".concat(start_url),
            "display": "standalone",
            "background_color": "#fafafa",
            "orientation": "any",
            "theme_color": "".concat(designColor),
            "description": "".concat(motto),
            "icons": []
        };
    }
};
var extendManifest = function(manifest, head) {
    var icon_60 = Checkers.objChildExists(head, "data") && Checkers.objChildExists(head.data, "icon_60") ? head.data.icon_60 : "";
    var icon_76 = Checkers.objChildExists(head, "data") && Checkers.objChildExists(head.data, "icon_76") ? head.data.icon_76 : "";
    var icon_120 = Checkers.objChildExists(head, "data") && Checkers.objChildExists(head.data, "icon_120") ? head.data.icon_120 : "";
    var icon_152 = Checkers.objChildExists(head, "data") && Checkers.objChildExists(head.data, "icon_152") ? head.data.icon_152 : "";
    var icon_256 = Checkers.objChildExists(head, "data") && Checkers.objChildExists(head.data, "icon_256") ? head.data.icon_256 : "";
    var icon = Checkers.objChildExists(head, "data") && Checkers.objChildExists(head.data, "icon") ? head.data.icon : "";
    if (icon_60 != null && icon_60 != "") {
        manifest.icons.push({
            "src": "".concat(icon_60),
            "sizes": "60x60",
            "type": "image/png",
            "purpose": "maskable"
        });
    }
    if (icon_76 != null && icon_76 != "") {
        manifest.icons.push({
            "src": "".concat(icon_76),
            "sizes": "76x76",
            "type": "image/png",
            "purpose": "maskable"
        });
    }
    if (icon_120 != null && icon_120 != "") {
        manifest.icons.push({
            "src": "".concat(icon_120),
            "sizes": "120x120",
            "type": "image/png",
            "purpose": "maskable"
        });
    }
    if (icon_152 != null && icon_152 != "") {
        manifest.icons.push({
            "src": "".concat(icon_152),
            "sizes": "152x152",
            "type": "image/png",
            "purpose": "maskable"
        });
    }
    if (icon_256 != null && icon_256 != "") {
        manifest.icons.push(// {
        // 	"src": `${icon_256}`,
        // 	"sizes": "192x192",
        // 	"type": "image/png",
        // 	"purpose": "maskable"
        // },
        {
            "src": "".concat(icon_256),
            "sizes": "256x256",
            "type": "image/png",
            "purpose": "any"
        });
    }
    if (icon != null && icon != "") {
        manifest.icons.push({
            "src": "".concat(icon),
            "sizes": "1024x1024",
            "type": "image/png",
            "purpose": "maskable"
        });
    }
    return manifest;
};
var getPropertyPricingData = function(propertyId, pricingData, fetchWebhotelierPrices) {
    if (pricingData == null) {
        return null;
    }
    if (!fetchWebhotelierPrices) {
        return null;
    }
    var propertyPrice = pricingData.filter(function(item) {
        return item.propertyId === propertyId;
    });
    if (_class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidArray */ .Z.isValidArray(propertyPrice)) {
        var singlePrice = propertyPrice[0];
        if (_class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidPositiveNumber */ .Z.isValidPositiveNumber(singlePrice.price)) {
            return singlePrice;
        }
        return null;
    }
    return null;
};
var getBedroomPricingData = function(bedroomId, pricingData, fetchWebhotelierPrices) {
    if (pricingData == null) {
        return null;
    }
    if (!fetchWebhotelierPrices) {
        return null;
    }
    var bedroomPrice = pricingData.filter(function(item) {
        return item.bedroomId === bedroomId;
    });
    if (Checkers.isValidArray(bedroomPrice)) {
        var singlePrice = bedroomPrice[0];
        if (Checkers.isValidPositiveNumber(singlePrice.price)) {
            return singlePrice;
        }
        return null;
    }
    return null;
};
var fetchBuilderSettingByKey = function(builderSettingsData, key) {
    var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (builderSettingsData == null || builderSettingsData == undefined) {
        return defaultValue;
    }
    if (builderSettingsData["settings"] == null || builderSettingsData["settings"] == undefined) {
        return defaultValue;
    }
    if (builderSettingsData["settings"][key] != undefined) {
        return builderSettingsData["settings"][key];
    }
    return builderSettingsData["settings"]["builder"][key];
};
var useWindowSize = function() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        width: undefined,
        height: undefined
    }), windowSize = ref[0], setWindowSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleResize = // only execute all the code below in client side
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
};
var randomCoordinateFactor = function() {
    return Math.random() / 100;
};
var textColor = function(darkMode) {
    if (darkMode === true || darkMode === "1") {
        return "text-light-color";
    }
    return "";
};
var btnTextColor = function(darkMode) {
    if (darkMode === true || darkMode === "1") {
        return "text-white";
    }
    return "text-black";
};
var isDarkMode = function(darkMode) {
    if (darkMode === true || darkMode === "1") {
        return true;
    }
    return false;
};
var updateBedrooms = function(value, setterFunction) {
    if (value.hasOwnProperty("value")) {
        if (value.value == "all") {
            setterFunction(0);
        } else {
            setterFunction(value.value);
        }
        ;
    }
};
var getBedroomValue = function(bedrooms, bedroomOptions) {
    var value = null;
    bedroomOptions.forEach(function(item) {
        if (item.value == bedrooms) {
            value = item;
        }
    });
    return value;
};
var getUnavailablePropertiesOpacity = function(availabilityStatus, unavailablePropertiesOpacity) {
    return availabilityStatus == 0 && _class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidNumber */ .Z.isValidNumber(unavailablePropertiesOpacity) ? unavailablePropertiesOpacity : 1;
};
var getPropertyViewType = function(availabilityStatus, propertiesViewType, unavailabelPropertiesViewType) {
    if (availabilityStatus == null) {
        return propertiesViewType;
    }
    if (availabilityStatus == 1) {
        return propertiesViewType;
    }
    if (availabilityStatus == 0) {
        return unavailabelPropertiesViewType;
    }
    return propertiesViewType;
};
var enableBookingBtn = function(propertyInitialAvailability, priceLoading, personsForBooking, dateRangeValid) {
    return (propertyInitialAvailability || priceLoading) && _class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidPositiveNumber */ .Z.isValidPositiveNumber(personsForBooking) && dateRangeValid;
};
var getHomepageUrl = function(defaultUrl, useRedirectUrl, homePageUrl) {
    if (useRedirectUrl && _class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidString */ .Z.isValidString(homePageUrl)) {
        return (_class_Checkers__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isValidString */ .Z.isValidString(process.env.SCHEME) ? process.env.SCHEME : "https://") + homePageUrl;
    }
    return defaultUrl;
};
function queryStringToObject(queryString) {
    return new URLSearchParams(queryString);
}


/***/ }),

/***/ 28207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MainLayout; }
});

// EXTERNAL MODULE: ../../shared/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(82770);
// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ./components/Header.tsx + 7 modules
var Header = __webpack_require__(60314);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/@fancyapps/ui/dist/fancybox.esm.js
var fancybox_esm = __webpack_require__(46797);
// EXTERNAL MODULE: ../../shared/node_modules/@mui/material/LinearProgress/LinearProgress.js + 1 modules
var LinearProgress = __webpack_require__(91779);
// EXTERNAL MODULE: ../../shared/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(31969);
// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(23158);
;// CONCATENATED MODULE: ./components/header/types/HeaderPacer.tsx





var HeaderPacer = function() {
    var mainPacer = (0,es/* useSelector */.v9)(function(state) {
        return state["uiData"]["mainPacer"];
    });
    var rgbDesignColor = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "designColor");
    });
    var scrollToTop = function() {
        if (window != undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant"
            });
        }
    };
    (0,react.useEffect)(function() {
        if (mainPacer) {
            scrollToTop();
        }
    }, [
        scrollToTop,
        mainPacer
    ]);
    return mainPacer ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pacer",
        style: {
            color: rgbDesignColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinearProgress/* default */.Z, {
            sx: {
                backgroundColor: "white"
            },
            color: "inherit"
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

// EXTERNAL MODULE: ./components/BottomSections.tsx + 7 modules
var BottomSections = __webpack_require__(64481);
// EXTERNAL MODULE: ../../shared/node_modules/next/dynamic.js
var dynamic = __webpack_require__(18256);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/FooterWrapper.tsx




var Scripts = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7452), __webpack_require__.e(9764), __webpack_require__.e(5419)]).then(__webpack_require__.bind(__webpack_require__, 85419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85419)
            ];
        }
    },
    ssr: false
});
var FooterWrapper = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSections["default"], {
                footerPaddingClass: !props.isDesktop ? "search-xs-p-b-70" : "",
                isDesktop: props.isDesktop,
                contactSection: props.app.showContactSection,
                footerSection: true,
                app_data: props.app_data,
                app: props.app,
                head: props.head,
                locations: props.locations,
                footer: props.footer,
                htmlSections: props.hasOwnProperty("html_sections") ? props.html_sections : null
            }, "bottom_section"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Scripts, {})
        ]
    });
};

// EXTERNAL MODULE: ../../shared/node_modules/next/router.js
var next_router = __webpack_require__(34357);
// EXTERNAL MODULE: ./redux/actions.js
var actions = __webpack_require__(46093);
;// CONCATENATED MODULE: ./components/header/types/LoaderComponent.tsx





var LoaderComponent = function() {
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var mainPacerHandler = function(value) {
        dispatch((0,actions/* updateMainPacer */.P9)(value));
    };
    (0,react.useEffect)(function() {
        var handleStart = function(url) {
            return url !== router.asPath && mainPacerHandler(true);
        };
        var handleComplete = function(url) {
            return url === router.asPath && mainPacerHandler(false);
        };
        router.events.on("routeChangeStart", handleStart);
        router.events.on("routeChangeComplete", handleComplete);
        router.events.on("routeChangeError", handleComplete);
        return function() {
            router.events.off("routeChangeStart", handleStart);
            router.events.off("routeChangeComplete", handleComplete);
            router.events.off("routeChangeError", handleComplete);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

// EXTERNAL MODULE: ../../shared/node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(91932);
;// CONCATENATED MODULE: ./components/header/types/MainLayoutSkeleton.tsx



var MainLayoutSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " no-padding no-overflow h-100 p-b-40",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        height: 400,
                        width: "100%"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 60,
                                        width: "100%",
                                        className: "m-b-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 27,
                                        width: "100%",
                                        className: "m-b-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 27,
                                        width: "100%",
                                        className: "m-b-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 27,
                                        width: "100%",
                                        className: "m-b-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 150,
                                        width: "100%",
                                        className: "m-b-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 27,
                                        width: "100%",
                                        className: "m-b-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 27,
                                        width: "100%",
                                        className: "m-b-20"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 150,
                                        width: "100%",
                                        className: "m-b-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        height: 250,
                                        width: "100%",
                                        className: "m-b-20"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./layouts/MainLayout.tsx










function MainLayout(props) {
    var ref = (0,react.useState)(null), urlHref = ref[0], setUrlHref = ref[1];
    react.useEffect(function() {
        fancybox_esm/* Fancybox.bind */.KR.bind("[data-fancybox]", {
            Image: {
                zoom: false
            }
        });
        if (window !== undefined) {
            setUrlHref(window.location.href + "/");
        }
    }, [
        urlHref
    ]);
    var mainPacer = (0,es/* useSelector */.v9)(function(state) {
        return state["uiData"]["mainPacer"];
    });
    var disablePacer = false;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header["default"], (0,_object_spread/* default */.Z)({
                referer: urlHref
            }, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderPacer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderComponent, {}),
            !mainPacer || disablePacer ? props.children : /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayoutSkeleton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWrapper, (0,_object_spread/* default */.Z)({}, props))
        ]
    });
}


/***/ })

}]);